var FF_A = window.FF_A || '';
/* ==========================================================================
   FurrFlora shop + cart
   --------------------------------------------------------------------------
   Works in two modes:
   1. DEMO (default): full cart UI; checkout shows a "connect Shopify" note.
   2. SHOPIFY: fill in SHOPIFY_CONFIG below and checkout creates a real
      Shopify cart via the Storefront API, then redirects to Shopify's
      hosted, secure checkout. See README.md for setup steps.
   Display prices here are for the page only; Shopify's prices are what
   the customer is actually charged at checkout.
   ========================================================================== */

const SHOPIFY_CONFIG = {
  shopDomain: 'kjvcc7-cy.myshopify.com',            // the FurrFlora store (connected 2026-10-15)
  storefrontToken: 'ad81469145285d6a55a7174d95b60123', // public Storefront API token from the Headless channel (safe to publish)
  apiVersion: '2025-07',
  // Checkout is open to shoppers (owner, 2026-10-26). Set to false to close it again ("Checkout isn't open yet").
  open: true,
};

/* ---------- product lines (sections on the shop page) ---------- */
// Product copy and claims, confirmed by the owner (2026-10-14). Prices further down are still placeholders.
const GROUPS = {
  diffuser: {
    title: 'CalmPod Diffuser',
    eyebrow: 'Calming pheromone plug-in',
    intro: 'A drug-free plug-in that releases the calming signals your pet already understands. Odorless to you, steady for them. Choose the cat or dog formula above.',
    lede: 'A drug-free plug-in diffuser that releases the calming signals your pet already understands. Odorless to you, steady for them.',
    usesPet: true,
    points: [['drop', 'Drug-free'], ['nose', 'Odorless to you'], ['home', 'Up to 700 sq ft'], ['clock', '30 days per refill']],
    details: [
      ['How to use', 'Twist a refill into the diffuser and plug it into an outlet in the room your pet uses most. Leave it on, and replace the refill every 30 days. See the <a href="/?view=info#how-to-use">placement guide</a>.'],
      ['What’s inside', 'Natural pheromones for pets, in natural, pet-safe ingredients: the feline facial pheromone for cats, or the canine appeasing pheromone for dogs. Each 48 ml refill lasts about 30 days. <a href="/?view=info#science">Read the science</a>.'],
      ['Safety', 'Drug-free and odorless to people. Each formula only signals its own species. Keep refills out of reach of children. <a href="/?view=info#safety">Full safety info</a>.'],
    ],
  },
  refills: {
    title: 'CalmPod Refills',
    eyebrow: 'Keep the calm going',
    intro: 'Each refill lasts about 30 days and fits every FurrFlora diffuser. Choose 1, 2 or 3, and subscribe for a lower price on every delivery. Skip or cancel anytime.',
    lede: 'Each refill lasts about 30 days and fits every FurrFlora diffuser. Subscribe and they arrive before you run out.',
    usesPet: true,
    points: [['clock', '~30 days per refill'], ['back', 'Skip or cancel anytime'], ['drop', 'Drug-free'], ['box', 'Recyclable glass']],
    details: [
      ['How to refill', 'Unplug the diffuser, twist out the empty refill, twist in the new one and plug it back in. That’s it.'],
      ['Subscriptions', 'Choose a delivery every 30, 60 or 90 days and pay the lower subscription price on every order. Skip, change dates or cancel anytime from your account.'],
      ['Which formula?', 'Match the refill to your pet: Feline Formula for cats, Canine Formula for dogs. With a cat and a dog, choose The Calm Mix with 2 or 3 refills and pick Feline or Canine for each refill.'],
    ],
  },
  // CalmMist, the calming spray for cats and dogs (dog version added 2026-10-18). Wording follows the product photos; the PRICE is still a placeholder
  spray: {
    title: 'CalmMist',
    eyebrow: 'Calming spray for cats and dogs',
    usesPet: true,
    intro: 'Calm that travels: a quick spray for carriers, bedding and new places, for the moments a plug-in can’t reach.',
    lede: 'Calm that travels: a quick spray for carriers, bedding and new places, for the moments a plug-in can’t reach.',
    points: [['heart', 'For cats or dogs'], ['box', 'Portable 60 ml bottle'], ['clock', 'About 30 days per bottle'], ['home', 'No plug needed']],
    details: [
      ['How to use', 'Use 8 to 10 sprays each time on beds, pet carriers and your pet’s places of comfort around the house. Never spray directly onto your pet, and follow the labeled waiting time before your pet goes in. At that rate a bottle lasts about 30 days.'],
      ['What’s inside', 'Natural pheromones for pets, in natural, pet-safe ingredients.'],
      ['Where it helps', 'Vet visits, car journeys, new surroundings, loud noises, visitors at home and changes in routine. For calm all day at home, pair it with the CalmPod diffuser.'],
      ['Safety', 'Never spray directly onto your pet: use it on beds, carriers and resting places. Keep out of reach of children, and avoid eyes and food surfaces.'],
    ],
  },
};

// `ver` is added to the file address when a set's photos are replaced, so browsers fetch the new ones
const PHOTO = (n, alt, set = 'dog-starter', ver = '') => ({ large: `${FF_A}${set}-${n}.jpg${ver && `?v=${ver}`}`, thumb: `${FF_A}${set}-${n}-thumb.jpg${ver && `?v=${ver}`}`, alt });
// Every Starter Kit set uses the same order, so switching plug keeps the matching shot:
// dogs: 1 kit + box, 2 plugged into the wall, 3 owner with dog, 4 features, 5 "asking for calm?"
// cats: 1 kit + box, 2 features, 3 owner with cats, 4 plugged into the wall, 5 "asking for calm?"
const DOG_STARTER_PHOTOS = [ // US (Type A) plug. CalmPod-branded versions (v2)
  { ...PHOTO(1, 'FurrFlora CalmPod Diffuser starter kit for dogs: the white plug-in diffuser with a 48 ml CalmPod refill, next to its box', 'dog-starter', 2), card: FF_A + 'dog-starter-1-card.jpg?v=2' },
  PHOTO(2, 'The FurrFlora CalmPod diffuser plugged into a wall while a golden retriever sleeps on its bed. Helps with time alone, visitors and noise, and new routines', 'dog-starter', 2),
  PHOTO(3, 'A woman hugging her golden retriever beside the FurrFlora CalmPod starter kit. Made for dogs, time to settle, simple routine, positive habits, refillable 48 ml design', 'dog-starter', 2),
  PHOTO(4, 'FurrFlora CalmPod diffuser for dogs: made for dogs, simple plug-in design, 48 ml refill, for a calmer home', 'dog-starter', 2),
  PHOTO(5, 'Is your dog asking for calm? Signs include excessive barking, pacing, destructive chewing, whining when alone, hiding or trembling, and indoor marking', 'dog-starter', 2),
];
// the same shots with the UK (Type G) plug, shown when the UK plug is chosen
const DOG_STARTER_UK_PHOTOS = [ // CalmPod-branded versions (v2)
  { ...PHOTO(1, 'FurrFlora CalmPod Diffuser starter kit for dogs with a UK plug: the white plug-in diffuser with a 48 ml CalmPod refill, next to its box', 'dog-starter-uk', 3), card: FF_A + 'dog-starter-uk-1-card.jpg?v=2' },
  PHOTO(2, 'The FurrFlora CalmPod diffuser plugged into a UK wall socket while a golden retriever sleeps on its bed. Helps with time alone, visitors and noise, and new routines', 'dog-starter-uk', 3),
  PHOTO(3, 'A woman hugging her golden retriever beside the FurrFlora CalmPod starter kit with a UK plug. Made for dogs, time to settle, simple routine, positive habits, refillable 48 ml design', 'dog-starter-uk', 3),
  PHOTO(4, 'FurrFlora CalmPod diffuser for dogs with a UK plug: made for dogs, simple plug-in design, 48 ml refill, for a calmer home', 'dog-starter-uk', 3),
  PHOTO(5, 'Is your dog asking for calm? Signs include excessive barking, pacing, destructive chewing, whining when alone, hiding or trembling, and indoor marking', 'dog-starter-uk', 3),
];
// ...and with the EU (Type C/F) plug, shown when the EU plug is chosen
const DOG_STARTER_EU_PHOTOS = [ // CalmPod-branded versions (v3: photos 1, 3 and 4 now say "+ 2 refills" on the box)
  { ...PHOTO(1, 'FurrFlora CalmPod Diffuser starter kit for dogs with an EU plug: the white plug-in diffuser with a 48 ml CalmPod refill, next to its box', 'dog-starter-eu', 4), card: FF_A + 'dog-starter-eu-1-card.jpg?v=3' },
  PHOTO(2, 'The FurrFlora CalmPod diffuser plugged into an EU wall socket while a golden retriever sleeps on its bed. Helps with time alone, visitors and noise, and new routines', 'dog-starter-eu', 4),
  PHOTO(3, 'A woman hugging her golden retriever beside the FurrFlora CalmPod starter kit with an EU plug. Made for dogs, time to settle, simple routine, positive habits, refillable 48 ml design', 'dog-starter-eu', 4),
  PHOTO(4, 'FurrFlora CalmPod diffuser for dogs with an EU plug: made for dogs, simple plug-in design, 48 ml refill, for a calmer home', 'dog-starter-eu', 4),
  PHOTO(5, 'Is your dog asking for calm? Signs include excessive barking, pacing, destructive chewing, whining when alone, hiding or trembling, and indoor marking', 'dog-starter-eu', 4),
];
// Cat starter kit, US (Type A) plug
const CAT_STARTER_PHOTOS = [ // CalmPod-branded versions (v2)
  { ...PHOTO(1, 'FurrFlora CalmPod Diffuser starter kit for cats: the white plug-in diffuser with a 48 ml CalmPod refill, next to its green box', 'cat-starter', 2), card: FF_A + 'cat-starter-1-card.jpg?v=2' },
  PHOTO(2, 'Round-the-clock calm: the FurrFlora CalmPod diffuser for cats, scent-free for people and pets, plug in and let it work, helps create a calmer home', 'cat-starter', 2),
  PHOTO(3, 'A woman relaxing with two sleeping cats beside the FurrFlora CalmPod starter kit. Non-sedating, odorless, long-lasting refill care', 'cat-starter', 2),
  PHOTO(4, 'A tabby cat asleep on its bed beside the FurrFlora CalmPod diffuser plugged into the wall', 'cat-starter', 2),
  PHOTO(5, 'Is your cat asking for calm? Signs include spraying or marking, fighting, furniture scratching, constant meowing, hissing or growling, and hiding', 'cat-starter', 2),
];
// ...and with the UK (Type G) plug, shown when the UK plug is chosen
const CAT_STARTER_UK_PHOTOS = [ // CalmPod-branded versions (v3: photo 3 corrected to show the UK plug)
  { ...PHOTO(1, 'FurrFlora CalmPod Diffuser starter kit for cats with a UK plug: the white plug-in diffuser with a 48 ml CalmPod refill, next to its green box', 'cat-starter-uk', 4), card: FF_A + 'cat-starter-uk-1-card.jpg?v=3' },
  PHOTO(2, 'Round-the-clock calm: the FurrFlora CalmPod diffuser for cats with a UK plug, scent-free for people and pets, plug in and let it work, helps create a calmer home', 'cat-starter-uk', 4),
  PHOTO(3, 'A woman relaxing with two sleeping cats beside the FurrFlora CalmPod starter kit with a UK plug. Non-sedating, odorless, long-lasting refill care', 'cat-starter-uk', 4),
  PHOTO(4, 'Trusted by cat homes: a tabby cat asleep on its bed beside the FurrFlora CalmPod diffuser plugged into a UK wall socket. 95% noticed a calmer mood, 94% saw less tension in multi-cat spaces, 89% reported less scratching and marking', 'cat-starter-uk', 5),
  PHOTO(5, 'Is your cat asking for calm? Signs include spraying or marking, fighting, furniture scratching, constant meowing, hissing or growling, and hiding', 'cat-starter-uk', 4),
];
// ...and with the EU (Type C/F) plug, shown when the EU plug is chosen
const CAT_STARTER_EU_PHOTOS = [ // CalmPod-branded versions (v2)
  { ...PHOTO(1, 'FurrFlora CalmPod Diffuser starter kit for cats with an EU plug: the white plug-in diffuser with a 48 ml CalmPod refill, next to its green box', 'cat-starter-eu', 3), card: FF_A + 'cat-starter-eu-1-card.jpg?v=2' },
  PHOTO(2, 'Round-the-clock calm: the FurrFlora CalmPod diffuser for cats with an EU plug, scent-free for people and pets, plug in and let it work, helps create a calmer home', 'cat-starter-eu', 3),
  PHOTO(3, 'A woman relaxing with two sleeping cats beside the FurrFlora CalmPod starter kit with an EU plug. Non-sedating, odorless, long-lasting refill care', 'cat-starter-eu', 3),
  PHOTO(4, 'Trusted by cat homes: a tabby cat asleep on its bed beside the FurrFlora CalmPod diffuser plugged into an EU wall socket. 95% noticed a calmer mood, 94% saw less tension in multi-cat spaces, 89% reported less scratching and marking', 'cat-starter-eu', 4),
  PHOTO(5, 'Is your cat asking for calm? Signs include spraying or marking, fighting, furniture scratching, constant meowing, hissing or growling, and hiding', 'cat-starter-eu', 3),
];
// CalmPod Refill for cats (single refill)
const CAT_REFILL_PHOTOS = [
  { ...PHOTO(1, 'FurrFlora CalmPod Refill for cats: a 48 ml refill on a green stand next to its box', 'cat-refill'), card: FF_A + 'cat-refill-1-card.jpg' },
  PHOTO(2, 'A tabby cat rubbing its cheek against a chair leg. Comfort, in their language: familiarity and reassurance, with the FurrFlora CalmPod Refill for cats', 'cat-refill'),
  PHOTO(3, 'A tabby cat curled up asleep in a green bed. Their space, their calm: supports a settled routine, encourages relaxation, made for cats', 'cat-refill'),
  PHOTO(4, 'A cat being stroked on an armchair beside the FurrFlora CalmPod Refill for cats. More moments to feel at home', 'cat-refill'),
];
// CalmPod Refill for dogs (single refill)
const DOG_REFILL_PHOTOS = [
  { ...PHOTO(1, 'FurrFlora CalmPod Refill for dogs: a 48 ml refill next to its box', 'dog-refill'), card: FF_A + 'dog-refill-1-card.jpg' },
  PHOTO(2, 'A golden retriever being stroked on a rug beside the FurrFlora CalmPod Refill for dogs. Calmer moments, closer company', 'dog-refill'),
  PHOTO(3, 'When life feels a little too much: new surroundings, noisy moments and time alone, with the FurrFlora CalmPod Refill for dogs', 'dog-refill'),
  PHOTO(4, 'A golden retriever asleep on its bed beside the FurrFlora CalmPod Refill for dogs. More settled, more at home', 'dog-refill'),
  PHOTO(5, 'A little reassurance, every day: familiar signals, a sense of comfort and support for settling, with the FurrFlora CalmPod Refill for dogs', 'dog-refill'),
];
// CalmMist calming spray for cats
const CAT_MIST_PHOTOS = [
  { ...PHOTO(1, 'FurrFlora CalmMist for cats: a white 60 ml calming spray bottle next to its green box', 'cat-mist'), card: FF_A + 'cat-mist-1-card.jpg' },
  PHOTO(2, 'A familiar routine, away from home: a cat in a carrier beside CalmMist for cats. For vet visits, car journeys and new surroundings', 'cat-mist'),
  PHOTO(3, 'Before they step inside: preparing a carrier with CalmMist. Add familiar bedding, apply to the empty carrier as directed, and follow the labeled waiting time', 'cat-mist'),
  PHOTO(4, 'Meet CalmMist, a calming spray for cats: made for cats, portable 60 ml bottle, simple pump spray, no plug needed', 'cat-mist'),
  PHOTO(5, 'A little calm, wherever life takes them: vet visits, car journeys, new surroundings, loud noises, visitors at home and changes in routine', 'cat-mist'),
];
// CalmMist calming spray for dogs (the owner's order, 2026-10-18)
const DOG_MIST_PHOTOS = [
  { ...PHOTO(1, 'FurrFlora CalmMist for dogs: a white 60 ml calming spray bottle next to its box, with a sleeping golden retriever on the label', 'dog-mist'), card: FF_A + 'dog-mist-1-card.jpg' },
  PHOTO(2, 'Set up their calm corner, a simple CalmMist routine: prepare their space with an empty dog bed or carrier, spray as directed on the label, then allow time to settle before your dog returns', 'dog-mist'),
  PHOTO(3, 'Ready for calmer trips? CalmMist for dogs, a little support away from home: prepare their travel space, apply as directed on the label, allow the stated waiting time and bring a familiar blanket', 'dog-mist'),
  PHOTO(4, 'A little support, more time to unwind: everyday reassurance when routines change, comfort away from home, and a compact 60 ml spray bottle that is easy to keep close', 'dog-mist'),
  PHOTO(5, 'Could your dog use a little more calm? Everyday situations that can feel overwhelming: new surroundings, loud noises, time alone, visitors at home, changes in routine, and vet or car trips', 'dog-mist'),
];
// CalmPod Refill 3-Pack for cats (one photo so far)
const CAT_REFILL3_PHOTOS = [
  { ...PHOTO(1, 'Three FurrFlora CalmPod Refills for cats, 48 ml each, in front of their three boxes', 'cat-refill3'), card: FF_A + 'cat-refill3-1-card.jpg' },
];
// CalmPod Refill 3-Pack for dogs (one photo so far)
// CalmPod Refill, 2 refills: this photo leads the gallery, followed by photos 2 onwards of the single-refill set (2026-10-19)
const CAT_REFILL2_PHOTO = { ...PHOTO(1, 'Two FurrFlora CalmPod Refills for cats, 48 ml each, in front of their two boxes', 'cat-refill2'), card: FF_A + 'cat-refill2-1-card.jpg' };
const DOG_REFILL2_PHOTO = { ...PHOTO(1, 'Two FurrFlora CalmPod Refills for dogs, 48 ml each, in front of their two boxes', 'dog-refill2'), card: FF_A + 'dog-refill2-1-card.jpg' };
const DOG_REFILL3_PHOTOS = [
  { ...PHOTO(1, 'Three FurrFlora CalmPod Refills for dogs, 48 ml each, in front of their three boxes', 'dog-refill3'), card: FF_A + 'dog-refill3-1-card.jpg' },
];
// Starter Kit, 2 or 3 kits: this photo leads the gallery, followed by photos 2 to 5 of the usual set
const DOG_STARTER_2KITS_PHOTO = { ...PHOTO(1, 'Two FurrFlora CalmPod Diffuser starter kit boxes for dogs', 'dog-starter-x2'), card: FF_A + 'dog-starter-x2-1-card.jpg' };
const DOG_STARTER_3KITS_PHOTO = { ...PHOTO(1, 'Three FurrFlora CalmPod Diffuser starter kit boxes for dogs', 'dog-starter-x3'), card: FF_A + 'dog-starter-x3-1-card.jpg' };
const CAT_STARTER_2KITS_PHOTO = { ...PHOTO(1, 'Two FurrFlora CalmPod Diffuser starter kit boxes for cats', 'cat-starter-x2'), card: FF_A + 'cat-starter-x2-1-card.jpg' };
const CAT_STARTER_3KITS_PHOTO = { ...PHOTO(1, 'Three FurrFlora CalmPod Diffuser starter kit boxes for cats', 'cat-starter-x3'), card: FF_A + 'cat-starter-x3-1-card.jpg' };
// CalmPod Refill 3-Pack as The Calm Mix: one photo per combination (keys match the mix variants)
// The Calm Mix with 2 refills: one for cats and one for dogs (2026-10-19)
const MIX_1_1_PHOTOS = [
  { ...PHOTO(1, 'The Calm Mix: one FurrFlora CalmPod refill for cats and one for dogs, 48 ml each, with their boxes', 'refill2-mix-1-1'), card: FF_A + 'refill2-mix-1-1-1-card.jpg' },
];
const MIX_2_1_PHOTOS = [
  { ...PHOTO(1, 'The Calm Mix: two FurrFlora CalmPod refills for cats and one for dogs, with their boxes', 'refill3-mix-2-1'), card: FF_A + 'refill3-mix-2-1-1-card.jpg' },
];
const MIX_1_2_PHOTOS = [
  { ...PHOTO(1, 'The Calm Mix: one FurrFlora CalmPod refill for cats and two for dogs, with their boxes', 'refill3-mix-1-2'), card: FF_A + 'refill3-mix-1-2-1-card.jpg' },
];
// CalmPod infographic, "Non-stop support for a calmer home" (owner, 2026-10-19): photo 3 of every Starter Kit gallery,
// the cat version for cats and the dog version for dogs. Not on the Refill page (owner). Every set gets it in the same
// place, so switching plug still keeps the matching shot.
const CALMPOD_INFO_CAT = PHOTO(1, 'Non-stop support for a calmer home, backed by pheromone science: the CalmPod diffuser with a 48 ml refill for cats. Simple plug-in setup, made for your cat’s space, steady pheromone release, replaceable 48 ml refill', 'calmpod-info-cat');
const CALMPOD_INFO_DOG = PHOTO(1, 'Non-stop support for a calmer home, backed by pheromone science: the CalmPod diffuser with a 48 ml refill for dogs. Simple plug-in setup, made for your dog’s space, steady pheromone release, replaceable 48 ml refill', 'calmpod-info-dog');
[CAT_STARTER_PHOTOS, CAT_STARTER_UK_PHOTOS, CAT_STARTER_EU_PHOTOS].forEach((set) => set.splice(2, 0, CALMPOD_INFO_CAT));
[DOG_STARTER_PHOTOS, DOG_STARTER_UK_PHOTOS, DOG_STARTER_EU_PHOTOS].forEach((set) => set.splice(2, 0, CALMPOD_INFO_DOG));

// Variant IDs come from Shopify admin (Products → variant → ID).
// Format: 'gid://shopify/ProductVariant/1234567890'. Pet products have a cat + dog variant;
// a product without a formula uses "any".
const PRODUCTS = [
  { id: 'starter', group: 'diffuser', name: 'FurrFlora CalmPod Starter Kit', desc: 'Everything you need for one room, ready to plug in.',
    includes: ['1 FurrFlora plug-in diffuser', '2 × 48 ml refills', 'Covers up to 700 sq ft'],
    price: 34.99, art: 'starter', plugs: ['UK', 'EU', 'US'],
    kitPlan: true, // offers a refill subscription sized to the kit (2 refills per diffuser)
    ribbon: 'Best seller', // gold banner on its shop card (owner, 2026-10-16)
    wide: true,    // on the shop page it gets a full-width card: photo left, choices right
    // 1, 2 or 3 kits on the same card (the 3-kit option replaced the old Calm Home Bundle).
    // Every kit comes with 2 refills. PLACEHOLDER prices: confirm the 2-kit price before launch.
    packs: [
      { n: 1, label: '1 kit' },
      { n: 2, label: '2 kits', price: 54.99, compareAt: 70, badge: 'Most popular', // was-prices £70 / £105 and the tag (owner, 2026-10-21; Shopify compare-at wins in the theme)
        includes: ['2 FurrFlora plug-in diffusers', '4 × 48 ml refills (2 per diffuser)', 'Two rooms covered'] },
      { n: 3, label: '3 kits', price: 69.99, compareAt: 105, badge: 'Best value',
        includes: ['3 FurrFlora plug-in diffusers', '6 × 48 ml refills (2 per diffuser)', 'One for every floor'] },
    ],
    // photos per formula; a `<pet>-<plug>` set (e.g. 'dog-UK') overrides it for that plug
    images: { dog: DOG_STARTER_PHOTOS, 'dog-UK': DOG_STARTER_UK_PHOTOS, 'dog-EU': DOG_STARTER_EU_PHOTOS, cat: CAT_STARTER_PHOTOS, 'cat-UK': CAT_STARTER_UK_PHOTOS, 'cat-EU': CAT_STARTER_EU_PHOTOS },
    // a size can have its own lead photo, keyed `<pet>-<kits>`; the rest of the gallery stays the usual set
    packImages: { 'cat-2': CAT_STARTER_2KITS_PHOTO, 'cat-3': CAT_STARTER_3KITS_PHOTO, 'dog-2': DOG_STARTER_2KITS_PHOTO, 'dog-3': DOG_STARTER_3KITS_PHOTO },
    // one Shopify variant per formula + plug, and the same again with -2 / -3 for the 2- and 3-kit options
    variants: { 'cat-uk': 'gid://shopify/ProductVariant/67746279260254', 'cat-eu': 'gid://shopify/ProductVariant/67746279129182', 'cat-us': 'gid://shopify/ProductVariant/67746278998110', 'dog-uk': 'gid://shopify/ProductVariant/67756643090526', 'dog-eu': 'gid://shopify/ProductVariant/67756643024990', 'dog-us': 'gid://shopify/ProductVariant/67756642959454',
      // 2 and 3 kits: Shopify Bundles products made of single kits (so Teemdrop receives single kits)
      'cat-uk-2': 'gid://shopify/ProductVariant/67767933730910', 'cat-eu-2': 'gid://shopify/ProductVariant/67767933698142', 'cat-us-2': 'gid://shopify/ProductVariant/67767933665374', 'dog-uk-2': 'gid://shopify/ProductVariant/67767921934430', 'dog-eu-2': 'gid://shopify/ProductVariant/67767921836126', 'dog-us-2': 'gid://shopify/ProductVariant/67767921737822',
      'cat-uk-3': 'gid://shopify/ProductVariant/67767934779486', 'cat-eu-3': 'gid://shopify/ProductVariant/67767934746718', 'cat-us-3': 'gid://shopify/ProductVariant/67767934713950',
      'dog-uk-3': 'gid://shopify/ProductVariant/67767995727966', 'dog-eu-3': 'gid://shopify/ProductVariant/67767995695198', 'dog-us-3': 'gid://shopify/ProductVariant/67767921082462' } },

  // CalmPod Refill: 1, 2 or 3 refills on one card (owner, 2026-10-18), for cats, dogs, or The Calm Mix (2 or 3 refills).
  // Prices are the owner's, in GBP: one-off 19.99 / 29.99 / 39.99, subscription 14.99 / 24.99 / 34.99 per delivery.
  { id: 'refill', group: 'refills', name: 'FurrFlora CalmPod Refill', desc: 'Keep the calm going, one month per refill.', wide: true,
    includes: ['1 × 48 ml refill (about 30 days)', 'Fits every FurrFlora diffuser'],
    price: 19.99, art: 'vial',
    images: { cat: CAT_REFILL_PHOTOS, dog: DOG_REFILL_PHOTOS, 'mix-1-1': MIX_1_1_PHOTOS, 'mix-2-1': MIX_2_1_PHOTOS, 'mix-1-2': MIX_1_2_PHOTOS },
    packImages: { 'cat-2': CAT_REFILL2_PHOTO, 'dog-2': DOG_REFILL2_PHOTO, 'cat-3': CAT_REFILL3_PHOTOS[0], 'dog-3': DOG_REFILL3_PHOTOS[0] },
    packs: [
      { n: 1, label: '1 refill' },
      { n: 2, label: '2 refills', price: 29.99, compareAt: 39.98, art: 'refill',
        includes: ['2 × 48 ml refills (about 60 days)', 'Fits every FurrFlora diffuser'] },
      { n: 3, label: '3 refills', price: 39.99, compareAt: 59.97, art: 'refill', badge: 'Best value',
        includes: ['3 × 48 ml refills (about 90 days)', 'Fits every FurrFlora diffuser'] },
    ],
    // a fixed subscription price per size (not a percentage)
    subscribe: { prices: { 1: 14.99, 2: 24.99, 3: 34.99 }, every: 30,
      // Seal Subscriptions: each Shopify refill product has its own plans, so they are listed per choice (null = none).
      // The 2- and 3-refill products are normal products since 2026-10-20 (Shopify Bundles can't be sold on subscription).
      planIds: {
      'cat-1': { 30: 'gid://shopify/SellingPlan/6764920926', 60: 'gid://shopify/SellingPlan/6765084766', 90: 'gid://shopify/SellingPlan/6765117534' },
      'dog-1': { 30: 'gid://shopify/SellingPlan/6764953694', 60: 'gid://shopify/SellingPlan/6765150302', 90: 'gid://shopify/SellingPlan/6765183070' },
      'mix-2-1': { 30: 'gid://shopify/SellingPlan/6772064350', 60: 'gid://shopify/SellingPlan/6772097118', 90: 'gid://shopify/SellingPlan/6772129886' },
      'mix-1-2': { 30: 'gid://shopify/SellingPlan/6772293726', 60: 'gid://shopify/SellingPlan/6772326494', 90: 'gid://shopify/SellingPlan/6772359262' },
      'cat-3': { 30: 'gid://shopify/SellingPlan/6772490334', 60: 'gid://shopify/SellingPlan/6772523102', 90: 'gid://shopify/SellingPlan/6772555870' },
      'dog-3': { 30: 'gid://shopify/SellingPlan/6772588638', 60: 'gid://shopify/SellingPlan/6772621406', 90: 'gid://shopify/SellingPlan/6772654174' },
      'cat-2': { 30: 'gid://shopify/SellingPlan/6772195422', 60: 'gid://shopify/SellingPlan/6772228190', 90: 'gid://shopify/SellingPlan/6772260958' },
      'dog-2': { 30: 'gid://shopify/SellingPlan/6772392030', 60: 'gid://shopify/SellingPlan/6772424798', 90: 'gid://shopify/SellingPlan/6772457566' },
      'mix-1-1': { 30: 'gid://shopify/SellingPlan/6771966046', 60: 'gid://shopify/SellingPlan/6771998814', 90: 'gid://shopify/SellingPlan/6772031582' },
      } },
    // The Calm Mix: with 2 or 3 refills, the customer picks Feline or Canine for each one
    mix: { name: 'The Calm Mix', min: 2 },
    // keys: <pet>-<refills>, or the mix itself (mix-<cats>-<dogs>). All sizes linked 2026-10-19.
    variants: {
      'cat-1': 'gid://shopify/ProductVariant/67756598362206', 'dog-1': 'gid://shopify/ProductVariant/67756641353822',
      'cat-2': 'gid://shopify/ProductVariant/67810417737822', 'dog-2': 'gid://shopify/ProductVariant/67810416885854', 'mix-1-1': 'gid://shopify/ProductVariant/67810416263262',
      'cat-3': 'gid://shopify/ProductVariant/67810412331102', 'dog-3': 'gid://shopify/ProductVariant/67810409971806', 'mix-2-1': 'gid://shopify/ProductVariant/67810412888158', 'mix-1-2': 'gid://shopify/ProductVariant/67810413871198' } },
  // Refill subscription offered with the CalmPod Starter Kit: 2 refills per diffuser in the kit.
  // Hidden from the shop grid; it is only added alongside a kit. Prices are one-off prices; the subscription prices are below.
  { id: 'refill-plan', group: 'refills', hidden: true, name: 'FurrFlora CalmPod Refill Subscription', desc: 'Refills for your CalmPod Starter Kit, delivered automatically.',
    includes: ['48 ml refills, 2 for each diffuser', 'Fits every FurrFlora diffuser'],
    price: 29.99, art: 'refill', images: { cat: CAT_REFILL_PHOTOS, dog: DOG_REFILL_PHOTOS }, // the refill photo in the cart
    // Nothing is charged for it at checkout: the kit's own refills (2 per diffuser) last about 60 days, so the
    // first delivery is charged when it ships, about this many days later. In Shopify its selling plans must be
    // set up the same way (no charge at checkout, first billing and delivery after 60 days).
    startsAfter: 60,
    packs: [
      { n: 2, label: '2 refills', price: 29.99 },
      { n: 4, label: '4 refills', price: 59.98 },
      { n: 6, label: '6 refills', price: 79.98 },
    ],
    // per delivery (owner, 2026-10-18): 2 refills 24.99 (same as the refill subscription), 4 refills 42.99, 6 refills 57.99
    subscribe: { prices: { 2: 24.99, 4: 42.99, 6: 57.99 }, every: 60, sellingPlans: { 30: '', 60: '', 90: '' } },
    variants: { 'cat-2': '', 'cat-4': '', 'cat-6': '', 'dog-2': '', 'dog-4': '', 'dog-6': '' } },

  // CalmMist calming spray for cats and dogs (Feline or Canine, like the refills). PLACEHOLDER price.
  { id: 'spray', group: 'spray', name: 'FurrFlora CalmMist', desc: 'Calm on the go, for carriers, vet visits and new places.',
    includes: ['60 ml spray bottle', 'About 30 days at 8 to 10 sprays a use'],
    // reduced from £24.99 (owner, 2026-10-19). In Shopify set the compare-at price to 24.99 on both CalmMist products.
    price: 14.99, compareAt: 24.99, art: 'deo', images: { cat: CAT_MIST_PHOTOS, dog: DOG_MIST_PHOTOS },
    variants: { cat: 'gid://shopify/ProductVariant/67756561465438', dog: 'gid://shopify/ProductVariant/67787926995038' } },

];

// Plug types for the diffusers
const PLUGS = {
  UK: { name: 'UK', type: 'Type G', where: 'UK & Ireland' },
  EU: { name: 'EU', type: 'Type C/F', where: 'Europe' },
  US: { name: 'US', type: 'Type A', where: 'US & Canada' },
};
const PLUG_KEY = 'furrflora-plug';
// first visit: guess from the browser's region; after that, remember the visitor's choice
function preferredPlug() {
  try { const saved = localStorage.getItem(PLUG_KEY); if (PLUGS[saved]) return saved; } catch { /* private mode */ }
  const region = ((navigator.languages && navigator.languages[0]) || navigator.language || '').split('-')[1] || '';
  if (['GB', 'IE', 'MT', 'CY'].includes(region.toUpperCase())) return 'UK';
  if (['US', 'CA', 'MX'].includes(region.toUpperCase())) return 'US';
  return region ? 'EU' : 'UK';
}
function savePlug(k) { try { localStorage.setItem(PLUG_KEY, k); } catch { /* private mode */ } }
const plugIcon = (k) => ({
  UK: '<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="5" y="4" width="22" height="24" rx="5"/><path d="M16 9v5M10.5 19h4M17.5 19h4"/></svg>',
  EU: '<svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="12"/><circle cx="11" cy="16" r="1.8"/><circle cx="21" cy="16" r="1.8"/></svg>',
  US: '<svg viewBox="0 0 32 32" aria-hidden="true"><rect x="5" y="4" width="22" height="24" rx="5"/><path d="M12 10v7M20 10v7"/><path d="M14.5 22a1.5 1.5 0 0 1 3 0v1.5h-3Z"/></svg>',
}[k]);

const STORAGE_KEY = 'furrflora-cart-v1';
const REFILL_PLAN_ID = 'refill-plan';

/* ---------- helpers ---------- */
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
/* ---------- live Shopify data (only inside the Shopify theme) ----------
   The theme layout writes window.FF_SHOP = { currency, variants: { <variant id>: [price in pence, compare-at, available] } }.
   When it is there, prices, savings and which options are offered all come from the store, in its currency.
   On the Netlify site there is no FF_SHOP, so the prices written in PRODUCTS below are used, in dollars. */
const LIVE = (() => { const s = window.FF_SHOP; return s && s.variants && Object.keys(s.variants).length ? s : null; })();
const CURRENCY = LIVE ? LIVE.currency : 'GBP'; // the store's own currency (Shopify base: GBP)
const MONEY_FMT = new Intl.NumberFormat(CURRENCY === 'USD' ? 'en-US' : 'en-GB', { style: 'currency', currency: CURRENCY });
const money = (n) => MONEY_FMT.format(n);
const liveVariant = (gid) => {
  const v = LIVE && gid && LIVE.variants[String(gid).split('/').pop()];
  return v ? { price: v[0] / 100, compare: v[1] / 100, available: Boolean(v[2]), plans: v[3] || {} } : null;
};
const petLabel = (pet) => (pet === 'dog' ? 'Canine' : 'Feline');
const okVariant = (gid) => { const v = liveVariant(gid); return Boolean(v && v.available); };
// in Shopify, a 3-pack whose all-cat and all-dog versions aren't for sale is sold only as The Calm Mix
const mixOnly = (p) => Boolean(LIVE && p.mix && !Object.entries(p.variants).some(([key, id]) => !/^mix-/.test(key) && okVariant(id)));
const firstMix = (p) => Object.keys(p.variants).find((k) => /^mix-/.test(k) && okVariant(p.variants[k]));
const mixCounts = (pet) => { const m = /^mix-(\d+)-(\d+)$/.exec(pet || ''); return m ? { cat: +m[1], dog: +m[2] } : null; };
const mixText = (pet) => { const c = mixCounts(pet); return c ? `${c.cat} Feline + ${c.dog} Canine` : ''; };
const shortFormula = (pet) => (mixCounts(pet) ? `The Calm Mix: ${mixText(pet)}` : petLabel(pet));
const formulaLabel = (pet) => (mixCounts(pet) ? `The Calm Mix (${mixText(pet)})` : `${petLabel(pet)} Formula`);
const currentPet = () => document.body.dataset.pet || 'cat';
const usesPet = (p) => p.usesPet !== false;
// the name shown to shoppers: "... for Cats" / "... for Dogs" (or "for Cats & Dogs" for The Calm Mix)
const petFor = (p, pet = currentPet()) => (mixCounts(pet) ? pet : mixOnly(p) && firstMix(p) ? firstMix(p) : p.pets && !p.pets.includes(pet) ? p.pets[0] : pet); // cat-only items stay "cat"
const fullName = (p, pet = currentPet(), who = petFor(p, pet)) => (usesPet(p) || p.pets ? `${p.name} for ${mixCounts(who) ? 'Cats & Dogs' : who === 'dog' ? 'Dogs' : 'Cats'}` : p.name);
const findProduct = (id) => PRODUCTS.find((x) => x.id === id);
// old product ids that are now a size option of another product (old links and saved carts still work)
const MERGED = { bundle: { id: 'starter', pack: 3 }, 'refill-1': { id: 'refill', pack: 1 } };
// the Shopify variant for a choice of pet (or Calm Mix), plug and size
const variantIdFor = (p, pet, plug, pack) => {
  const kits = (pack || 1) > 1 ? `-${pack}` : '';
  if (!p.variants) return '';
  if (p.plugs) return p.variants[`${pet}-${String(plug || '').toLowerCase()}${kits}`];
  if (p.packs && usesPet(p)) return mixCounts(pet) ? p.variants[pet] : p.variants[`${pet}-${pack || 1}`];
  return usesPet(p) ? p.variants[pet] : p.variants[`any${kits}`];
};
// size options (1 kit / 3 kits); a pack falls back to the product's own price and contents.
// With live Shopify data the price is the store's, the "was" price is Shopify's compare-at price
// (or, for a multi-pack, the same number of singles), and `available` says whether it can be bought.
const packOf = (p, n, pet, plug) => {
  const k = p.packs && (p.packs.find((x) => x.n === Number(n)) || p.packs[0]);
  const out = { n: 1, label: '', price: p.price, compareAt: p.compareAt, includes: p.includes, badge: p.badge, ...(k || {}) };
  if (!LIVE) return out;
  const who = usesPet(p) ? (pet || petFor(p)) : null;
  const where = p.plugs ? (plug || preferredPlug()) : null;
  let lv = liveVariant(variantIdFor(p, who, where, out.n));
  // a size sold only as The Calm Mix (e.g. 3 refills) still counts as on sale, at the mix's price
  if (!(lv && lv.available) && p.mix && !mixCounts(who)) {
    const mk = Object.keys(p.variants).find((key) => { const c = mixCounts(key); return c && c.cat + c.dog === out.n && okVariant(p.variants[key]); });
    if (mk) lv = liveVariant(p.variants[mk]);
  }
  out.available = Boolean(lv && lv.available);
  if (!lv) return out;
  out.price = lv.price;
  const planPrices = Object.values(lv.plans || {});
  if (planPrices.length) out.planPrice = Math.min(...planPrices) / 100; // the subscription price Shopify charges
  const singles = out.n > 1 ? packOf(p, 1, pet, plug).price * out.n : 0;
  out.compareAt = lv.compare > lv.price ? lv.compare : (singles > lv.price + 0.004 ? singles : undefined);
  return out;
};
// can this product be bought at all right now? (always yes on the Netlify site)
const sellable = (p) => !LIVE || Object.values(p.variants || {}).some((id) => { const v = liveVariant(id); return v && v.available; });
// is "Subscribe and save" set up for it? (needs selling plans in Shopify when running live)
const subLive = (p) => Boolean(p && p.subscribe) && (!LIVE || Object.values(p.subscribe.sellingPlans || {}).some(Boolean) || Object.values(p.subscribe.planIds || {}).some((o) => Object.values(o).some(Boolean)));
// can this exact choice (formula and size) be bought on subscription?
const subAt = (p, pet, pack) => {
  if (!subLive(p)) return false;
  const ids = p.subscribe.planIds;
  if (!ids) return true;
  const set = ids[mixCounts(pet) ? pet : `${pet}-${pack || 1}`];
  return Boolean(set) && (!LIVE || Object.values(set).some(Boolean));
};
const planIdFor = (p, pet, pack, every) => {
  const s = p.subscribe;
  if (s.planIds) return (s.planIds[mixCounts(pet) ? pet : `${pet}-${pack || 1}`] || {})[every];
  return (s.sellingPlans || {})[every];
};
const SUB_TEXT = /subscri|cancel anytime/i;
const packSave = (k) => (k.compareAt ? Math.round((1 - k.price / k.compareAt) * 100) : 0);
// Starter Kit: optional refill subscription sized to the kit (2 refills per diffuser)
const REFILL_PLAN = 'refill-plan'; // the old delayed kit plan (no longer offered; old cart lines become refill subscriptions)
// Kit + refill subscription (owner, 2026-10-20): the normal refill subscription, 1 refill per diffuser per delivery,
// charged today and sent with the kit (1 kit: 1 refill £14.99, 2 kits: 2 refills £24.99, 3 kits: 3 refills £34.99)
const KIT_REFILLS = 'refill';
const kitRefills = (n) => n;
const kitPlanPrice = (n, pet = currentPet()) => { const rp = findProduct(KIT_REFILLS); return subPriceOf(rp, packOf(rp, kitRefills(n), pet)); };
const kitPlanUI = (name) => `
  <div class="kit-plan" data-kit-plan>
    <p class="opt-label" id="${name}-label">Refills</p>
    <div class="purchase-opts" role="radiogroup" aria-labelledby="${name}-label">
    <label class="opt is-checked"><input type="radio" name="${name}" value="kit" checked> Kit only</label>
    <label class="opt opt-kit-sub"><input type="radio" name="${name}" value="kit-sub"> Kit + refill subscription<span class="opt-ribbon">Subscribe to Save More</span></label>
    <div class="freq kit-freq">
      <p class="kit-plan-note" data-plan-note></p>
      <label class="visually-hidden" for="${name}-freq">Refill delivery frequency</label>
      <select id="${name}-freq" data-kit-freq>
        <option value="30" selected>Every 30 days</option>
        <option value="60">Every 60 days</option>
        <option value="90">Every 90 days</option>
      </select>
      <p class="kit-plan-hint">We recommend every 30 days. Skip, change dates or cancel anytime.</p>
    </div>
    </div>
  </div>`;
const syncKitPlan = (wrap, n) => {
  if (!wrap) return;
  $$('.opt', wrap).forEach((o) => o.classList.toggle('is-checked', $('input', o).checked));
  const every = $('[data-kit-freq]', wrap).value;
  // each delivery choice shows the saving against buying the same refills one-off (owner, 2026-10-19)
  const rp = findProduct(KIT_REFILLS);
  const saved = subSaving(rp, packOf(rp, kitRefills(n), currentPet()));
  $$('[data-kit-freq] option', wrap).forEach((o) => { o.textContent = `Every ${o.value} days${saved > 0.004 ? ` · Save ${money(saved)}` : ''}`; });
  const r = kitRefills(n), price = money(kitPlanPrice(n));
  $('[data-plan-note]', wrap).innerHTML = `<strong>Never run out of your pet’s calm.</strong> Your ${n > 1 ? `${n} kits come with ${n} diffusers` : 'kit comes with a diffuser'} and ${2 * n} refills. Add a refill subscription and you’ll also get ${r} ${r > 1 ? 'refills' : 'refill'} now${n > 1 ? ' (1 per diffuser)' : ''}, then ${r} every ${every} days, so the calm never stops. <strong>${price} today</strong>, then ${price} every ${every} days.`;
};
// the chosen refill frequency in days, or null for "Kit only"
const kitPlanChoice = (wrap) => (wrap && $('input[value="kit-sub"]', wrap).checked ? $('[data-kit-freq]', wrap).value : null);
const packChoices = (p, name, chosen = 1) => p.packs.map((x) => {
  const k = packOf(p, x.n), on = k.n === Number(chosen);
  return `<label class="pack-opt${on ? ' is-checked' : ''}"><input type="radio" name="${name}" value="${k.n}" data-pack ${on ? 'checked' : ''}>
    <span class="pack-name">${k.label}</span><span class="pack-price">${money(k.price)}</span>${packSave(k) ? `<span class="pack-tag">Save ${packSave(k)}%</span>` : ''}</label>`;
}).join('');
// what a subscription delivery costs for a size: the product's fixed price for it, or a percentage off.
// With live Shopify prices, a fixed price keeps the same saving off the store's one-off price.
const subPriceOf = (p, k) => {
  if (LIVE && k.planPrice != null) return k.planPrice;
  const fixed = p.subscribe.prices && p.subscribe.prices[k.n || 1];
  if (fixed == null) return k.price * (1 - p.subscribe.discount);
  const own = (p.packs && p.packs.find((x) => x.n === (k.n || 1)) || {}).price || p.price;
  return LIVE ? Math.max(0, k.price - (own - fixed)) : fixed;
};
// a subscription's saving is measured against the regular price: for a multi-pack, the same number of singles
// (e.g. 3 refills: 3 x 19.99 = 59.97 against 34.99 a delivery), otherwise the one-off price
const regularPrice = (k) => (k.compareAt && k.compareAt > k.price ? k.compareAt : k.price);
const subSaving = (p, k) => regularPrice(k) - subPriceOf(p, k);
const fromPrice = (p) => { const base = packOf(p, 1); return subLive(p) ? subPriceOf(p, base) : base.price; };
const isShopifyReady = () => Boolean(SHOPIFY_CONFIG.shopDomain && SHOPIFY_CONFIG.storefrontToken);
// ?test-checkout on any address turns real checkout on for this browser tab only (for testing before launch)
const checkoutTestMode = (() => {
  try {
    if (new URLSearchParams(location.search).has('test-checkout')) sessionStorage.setItem('ff-test-checkout', '1');
    return sessionStorage.getItem('ff-test-checkout') === '1';
  } catch { return false; }
})();
const checkoutOpen = () => isShopifyReady() && (SHOPIFY_CONFIG.open || checkoutTestMode);

const ICONS = {
  drop: '<path d="M12 3s6 6.5 6 11a6 6 0 0 1-12 0c0-4.5 6-11 6-11Z"/><path d="m9.5 14.5 1.8 1.8 3.5-3.6"/>',
  nose: '<path d="M4 12c2-3 5-5 8-5s6 2 8 5c-2 3-5 5-8 5s-6-2-8-5Z"/><path d="M4 4l16 16"/>',
  home: '<path d="M4 11 12 4l8 7v8a1 1 0 0 1-1 1h-4v-5h-6v5H5a1 1 0 0 1-1-1Z"/>',
  clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
  back: '<path d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4"/>',
  box: '<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5Z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/>',
  heart: '<path d="M12 20s-7-4.3-8.8-8.6C1.8 8.1 3.9 4.8 7.2 4.8c1.9 0 3.3 1.1 4.8 2.8 1.5-1.7 2.9-2.8 4.8-2.8 3.3 0 5.4 3.3 4 6.6C19 15.7 12 20 12 20Z"/>',
};
/* ---------- customer reviews (real, supplied by the owner on 2026-10-14) ---------- */
// The star rating shown for a product is the average of the reviews for its family, worked out here,
// so it always matches the reviews people can read. Add new reviews to this list (and to the home page).
const REVIEWS = [
  { stars: 4, name: 'Rebecca H.', line: 'calmpod', text: 'Nothing really changed in the first few days. After a couple of weeks with CalmPod, my dogs seem to settle more easily in the evenings. They still have their noisy moments.' },
  { stars: 5, name: 'Sophie L.', line: 'calmpod', text: 'My dog usually follows me every time I get up. Since we started using CalmPod, he seems happier staying in his bed while I potter around. A small change, but lovely to see.' },
  { stars: 5, name: 'Daniel W.', line: 'calmpod', text: 'We moved recently and my cat spent most evenings behind the sofa. With CalmPod plugged into the living room, she’s gradually started joining us again. Yesterday she even claimed my seat.' },
  { stars: 5, name: 'Adam K.', line: 'calmpod', text: 'My cat normally disappears upstairs when anyone visits. We’ve been using CalmPod for a few weeks and she stayed in the room when my sister came over. Wasn’t expecting that.' },
  { stars: 5, name: 'Charlotte B.', line: 'calmpod', text: 'Bought CalmPod for the room where my dogs spend most of their time. It’s easy to forget it’s even there, and lately they’ve been spending more evenings snoozing beside each other.' },
  { stars: 5, name: 'Nathan P.', line: 'calmpod', text: 'Milo is usually pacing around while we’re trying to watch television. Since adding CalmPod to our evening routine, he seems more settled. Still steals the cushions, obviously.' },
  { stars: 4, name: 'Hannah T.', line: 'calmpod', text: 'My cats aren’t suddenly best friends, but things feel less tense around the house. We’ve been using CalmPod alongside giving them separate spaces, and we’re happy with the progress.' },
  { stars: 5, name: 'Olivia C.', line: 'calmpod', text: 'CalmPod was straightforward to set up, which I appreciated. My dog seems more comfortable spending time in the lounge again instead of hovering by the hallway.' },
  { stars: 5, name: 'Marcus J.', line: 'calmpod', text: 'We’ve tried making the house quieter for our rescue cat, and added CalmPod to her favourite room. She’s spending more time out with us now. Seeing her stretch out on the rug feels lovely.' },
  { stars: 5, name: 'Emily S.', line: 'calmmist', text: 'We introduced CalmMist while getting my cat used to her carrier at home. She’s started going in to investigate instead of avoiding it completely. We’re taking it slowly, but it feels like progress.' },
];
/* ---------- benefits, said plainly (shop cards, product pages) ---------- */
// Three quick reasons to buy each product, built only from claims the owner has confirmed.
const PERKS = {
  starter: ['Most pets settle within about 7 days', 'Drug-free and odorless to you', '2 refills included: about 60 days of calm'],
  refill: ['About 30 days of calm per refill', 'Choose 1, 2 or 3, or mix cat and dog', 'Fits every CalmPod diffuser'],
  spray: ['Calm for carriers, vet visits and travel', '8 to 10 sprays, no plug needed', 'About 30 days per bottle'],
};
// the product page's benefit lines: a bold promise, then the detail (confirmed claims only)
const PDP_POINTS = {
  starter: [['Most pets settle in about 7 days', 'calm builds with continuous use'], ['Drug-free, natural pheromones', 'odorless to you, made for cats or dogs'], ['Covers up to 700 sq ft', 'one diffuser per room or floor'], ['2 refills included', 'about 60 days of calm, ready to plug in']],
  refill: [['About 30 days per refill', 'works around the clock'], ['Fits every CalmPod diffuser', 'twist out, twist in'], ['Natural, pet-safe pheromones', 'odorless to you'], ['Subscribe and save', 'skip, change dates or cancel anytime']],
  spray: [['Calm on the go', 'for carriers, vet visits, car journeys and new places'], ['Quick and easy', '8 to 10 sprays on bedding or the carrier, no plug needed'], ['Natural, pet-safe pheromones', 'never sprayed directly onto your pet'], ['About 30 days per bottle', 'in a portable 60 ml spray']],
};
// days of use behind "That's about $0.58 a day" (confirmed: a kit's 2 refills ≈ 60 days, a refill ≈ 30, a spray bottle ≈ 30)
const DAYS_OF_USE = { starter: () => 60, refill: (n) => 30 * n, spray: () => 30 };
// "Bundle & save" rows on the product page (true savings only; badges come from the product data)
const bundleRows = (p, chosen = 1) => p.packs.filter((x) => packOf(p, x.n).available !== false).map((x) => {
  const k = packOf(p, x.n), on = k.n === Number(chosen);
  const saved = k.compareAt ? k.compareAt - k.price : 0;
  const detail = p.kitPlan ? `${k.n} diffuser${k.n > 1 ? 's' : ''} + ${k.n * 2} refills${k.n > 1 ? ` · ${money(k.price / k.n)} per kit` : ''}` : '';
  // diffusers show the saving as money in the shopper's currency (owner, 2026-10-21), other products as a %
  const tag = k.badge ? `<span class="bundle-tag${k.badge === 'Best value' ? '' : ' is-save'}">${k.badge}</span>` : saved > 0 ? `<span class="bundle-tag is-save">Save ${p.kitPlan ? money(saved) : `${packSave(k)}%`}</span>` : '';
  return `<label class="bundle-row${on ? ' is-checked' : ''}"><input type="radio" name="pack" value="${k.n}" data-pack ${on ? 'checked' : ''}>
    <span class="bundle-main"><span class="bundle-name">${k.label.replace(/\bkits?\b/, (w) => w[0].toUpperCase() + w.slice(1))}</span>${detail ? `<span class="bundle-detail">${detail}</span>` : ''}<span class="bundle-sub">${saved > 0 ? `You save ${money(saved)}` : 'Standard price'}</span></span>
    <span class="bundle-price"><strong>${money(k.price)}</strong>${k.compareAt ? `<s>${money(k.compareAt)}</s>` : ''}</span>${tag}</label>`;
}).join('');

// the "3 Everyday Benefits" band on each product page, per product line
const LINE_BENEFITS = {
  calmpod: { title: 'FurrFlora CalmPod <em>for a Calmer Pet</em>', items: [
    ['Supports Everyday Calm', 'Helps pets feel more settled during everyday changes.'],
    ['Encourages Relaxation', 'Supports quiet moments and a more relaxed routine.'],
    ['Helps With Stressful Habits', 'May help reduce stress-related scratching and marking.'] ] },
  calmmist: { title: 'FurrFlora CalmMist <em>for Calm on the Go</em>', items: [
    ['Calm Wherever They Go', 'Helps cats and dogs feel calmer in carriers, at the vet and in new places.'],
    ['Quick and Easy', '8 to 10 sprays on bedding or the carrier. No plug needed.'],
    ['Lasts About 30 Days', 'One 60 ml bottle covers about a month of everyday use.'] ] },
};
// Wording changed in Shopify's theme editor ("Product wording" section on the product page) arrives as
// window.FF_OVERRIDES; empty fields keep the site's own words. Not used on the plain website.
const escHTML = (t) => String(t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
(() => {
  const ov = window.FF_OVERRIDES || {};
  const filled = (t) => typeof t === 'string' && t.trim() !== '';
  Object.entries(ov.products || {}).forEach(([id, o]) => {
    const p = findProduct(id);
    if (!p) return;
    if (filled(o.desc)) p.desc = o.desc.trim().replace(/[<>]/g, ''); // used as text and inside HTML, so no angle brackets
    if (filled(o.points)) {
      PDP_POINTS[id] = o.points.split('\n').map((l) => l.trim()).filter(Boolean)
        .map((l) => { const [bold, ...rest] = l.split(/\s[-–—]\s/); return [escHTML(bold), escHTML(rest.join(' – '))]; });
    }
  });
  Object.entries(ov.bands || {}).forEach(([line, o]) => {
    const b = LINE_BENEFITS[line];
    if (!b) return;
    if (filled(o.title)) b.title = `${escHTML(o.title.trim())}${filled(o.titleEm) ? ` <em>${escHTML(o.titleEm.trim())}</em>` : ''}`;
    (o.items || []).forEach(([t, d], n) => { if (b.items[n] && filled(t)) b.items[n][0] = escHTML(t.trim()); if (b.items[n] && filled(d)) b.items[n][1] = escHTML(d.trim()); });
  });
})();
const CHECK = '<svg class="tick" viewBox="0 0 24 24" aria-hidden="true"><path d="m6.5 12.5 3.6 3.6 7.4-7.6"/></svg>';
const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
// a true saving to show on a card: the subscription discount, or the best multi-pack saving
const cardWas = (p) => { const k = packOf(p, 1); if (subLive(p)) return k.price; return !p.packs && k.compareAt > k.price ? k.compareAt : null; };
const cardSaving = (p) => {
  if (subLive(p)) return p.subscribe.prices ? (() => { const sizes = (p.packs || [{ n: 1 }]).filter((x) => packOf(p, x.n).available !== false && subAt(p, petFor(p), x.n)); const best = Math.max(...sizes.map((x) => subSaving(p, packOf(p, x.n)))); return `Subscribe &amp; save ${sizes.length > 1 ? 'up to ' : ''}${money(best)} a delivery`; })() : `Subscribe &amp; save ${Math.round(p.subscribe.discount * 100)}%`;
  const best = p.packs ? Math.max(0, ...p.packs.filter((x) => packOf(p, x.n).available !== false).map((x) => packSave(packOf(p, x.n)))) : 0;
  if (best > 0) return `Save up to ${best}% on multi-packs`;
  const k = packOf(p, 1);
  return !p.packs && k.compareAt > k.price ? `Save ${money(k.compareAt - k.price)}` : '';
};

const REVIEW_LINES = { calmpod: 'CalmPod', calmmist: 'CalmMist' };
const REVIEW_LINE_OF = { starter: 'calmpod', refill: 'calmpod', 'refill-plan': 'calmpod', spray: 'calmmist' };
const reviewsFor = (p) => REVIEWS.filter((r) => r.line === REVIEW_LINE_OF[p.id]);
const ratingFor = (p) => {
  const list = reviewsFor(p);
  return list.length ? { avg: Math.round((list.reduce((s, r) => s + r.stars, 0) / list.length) * 10) / 10, count: list.length } : null;
};
// five stars, filled to the rating (4.8 shows four and most of the fifth)
const starBar = (avg) => `<span class="star-bar" style="--fill:${(avg / 5) * 100}%" aria-hidden="true">★★★★★</span>`;
const ratingText = (r) => `Rated ${r.avg.toFixed(1)} out of 5 from ${r.count} review${r.count === 1 ? '' : 's'}`;
const cardRating = (p) => { const r = ratingFor(p); return r ? `<p class="card-rating" aria-label="${ratingText(r)}">${starBar(r.avg)}<span aria-hidden="true">${r.avg.toFixed(1)}</span></p>` : ''; };
const reviewCard = (r, i) => `
  <article class="review">
    <div class="stars" aria-label="${r.stars} out of 5 stars">${'★'.repeat(r.stars)}${'☆'.repeat(5 - r.stars)}</div>
    <blockquote>“${r.text}”</blockquote>
    <footer><span class="avatar a${(i % 5) + 1}" aria-hidden="true">${r.name[0]}</span><span><strong>${r.name}</strong><br>${REVIEW_LINES[r.line]}</span></footer>
  </article>`;

const icon = (k) => `<svg viewBox="0 0 24 24" aria-hidden="true">${ICONS[k]}</svg>`;

/* ---------- product art (inline SVG, no image downloads) ---------- */
function diffuserSVG(x = 0, y = 0, s = 1) {
  return `
  <g transform="translate(${x} ${y}) scale(${s})">
    <ellipse cx="60" cy="168" rx="46" ry="7" fill="#26213F" opacity=".08"/>
    <rect x="40" y="108" width="40" height="56" rx="13" class="liquid" opacity=".85"/>
    <rect x="46" y="116" width="7" height="38" rx="3.5" fill="#fff" opacity=".5"/>
    <path d="M18 54c0-26 19-40 42-40s42 14 42 40v40c0 14-10 22-24 22H42c-14 0-24-8-24-22Z" fill="#FFFDFA" stroke="#EAE1D8" stroke-width="1.5"/>
    <path d="M30 58c2-18 14-28 30-29" stroke="#fff" stroke-width="5" stroke-linecap="round" fill="none"/>
    <circle cx="60" cy="86" r="4.5" fill="#D9B27A"/>
  </g>`;
}
function vialSVG(x, y, r = 0, s = 1) {
  return `
  <g transform="translate(${x} ${y}) rotate(${r}) scale(${s})">
    <rect x="-16" y="-6" width="32" height="14" rx="4" fill="#FFFDFA" stroke="#EAE1D8"/>
    <rect x="-20" y="6" width="40" height="78" rx="14" class="liquid" opacity=".88"/>
    <rect x="-13" y="14" width="6" height="58" rx="3" fill="#fff" opacity=".5"/>
  </g>`;
}
function sprayBottleSVG(x = 0, y = 0, s = 1) {
  return `
  <g transform="translate(${x} ${y}) scale(${s})">
    <ellipse cx="62" cy="200" rx="44" ry="7" fill="#26213F" opacity=".08"/>
    <path d="M40 28h40l18 12v16H40Z" fill="#FFFDFA" stroke="#EAE1D8" stroke-width="1.5"/>
    <rect x="96" y="42" width="12" height="7" rx="2" fill="#E3D8CB"/>
    <path d="M50 56h24l-4 26H56Z" fill="#F1E9DD" stroke="#EAE1D8" stroke-width="1.5"/>
    <path d="M74 60c8 6 9 16 4 24" fill="none" stroke="#E3D8CB" stroke-width="6" stroke-linecap="round"/>
    <rect x="42" y="78" width="40" height="14" rx="5" fill="#FFFDFA" stroke="#EAE1D8" stroke-width="1.5"/>
    <rect x="26" y="88" width="72" height="110" rx="22" fill="#8FA876"/>
    <rect x="34" y="96" width="9" height="88" rx="4.5" fill="#fff" opacity=".28"/>
    <rect x="38" y="116" width="48" height="56" rx="10" fill="#FFF9EF"/>
    <path d="M62 160c-10-10-10-22 0-32 10 10 10 22 0 32Z" fill="#8FA876"/>
    <path d="M62 160v-26" stroke="#FFF9EF" stroke-width="2" stroke-linecap="round"/>
  </g>`;
}
function pouchSVG(x = 0, y = 0, s = 1) {
  return `
  <g transform="translate(${x} ${y}) scale(${s})">
    <ellipse cx="70" cy="198" rx="54" ry="7" fill="#26213F" opacity=".08"/>
    <rect x="58" y="14" width="24" height="18" rx="5" fill="#FFFDFA" stroke="#EAE1D8" stroke-width="1.5"/>
    <path d="M30 40c0-8 6-12 14-12h52c8 0 14 4 14 12l8 140c0 10-8 16-18 16H40c-10 0-18-6-18-16Z" fill="#B7C99D"/>
    <path d="M38 52h64" stroke="#fff" stroke-width="3" opacity=".5" stroke-linecap="round"/>
    <rect x="40" y="94" width="60" height="62" rx="12" fill="#FFF9EF"/>
    <path d="M70 146c-10-10-10-22 0-32 10 10 10 22 0 32Z" fill="#8FA876"/>
    <text x="70" y="88" text-anchor="middle" font-family="Nunito Sans, sans-serif" font-weight="800" font-size="13" fill="#2B3417">250 ml</text>
  </g>`;
}
function productArt(kind) {
  const mist = `
    <g class="pm-mist" fill="none" stroke-width="7" stroke-linecap="round">
      <path d="M100 30c-14-20 18-26 6-48s26-28 44-24"/>
      <path d="M104 30c10-22 38-14 34-40s30-26 56-18"/>
    </g>`;
  const spray = `
    <g class="pm-spray" fill="#B7C99D">
      <circle cx="132" cy="36" r="5"/><circle cx="146" cy="28" r="4"/><circle cx="148" cy="44" r="3.5"/>
      <circle cx="160" cy="34" r="3"/><circle cx="164" cy="22" r="2.5"/>
    </g>`;
  switch (kind) {
    case 'refill':
      return `<svg viewBox="0 0 240 190" aria-hidden="true"><g class="pm-float">
        ${vialSVG(80, 52, -8)}${vialSVG(160, 52, 8)}${vialSVG(120, 66, 0)}
        <ellipse cx="120" cy="168" rx="80" ry="8" fill="#26213F" opacity=".07"/></g></svg>`;
    case 'refill6':
      return `<svg viewBox="0 0 240 190" aria-hidden="true"><g class="pm-float">
        ${vialSVG(66, 30, -6, .78)}${vialSVG(104, 26, 0, .78)}${vialSVG(142, 26, 0, .78)}${vialSVG(178, 30, 6, .78)}
        ${vialSVG(92, 82, -4, .8)}${vialSVG(150, 82, 4, .8)}
        <ellipse cx="120" cy="170" rx="86" ry="8" fill="#26213F" opacity=".07"/></g></svg>`;
    case 'vial':
      return `<svg viewBox="0 0 240 190" aria-hidden="true"><g class="pm-float">
        ${vialSVG(120, 50, 0, 1.1)}<ellipse cx="120" cy="160" rx="40" ry="7" fill="#26213F" opacity=".07"/></g></svg>`;
    case 'bundle':
      return `<svg viewBox="0 0 300 190" aria-hidden="true" style="width:86%"><g class="pm-float">
        ${diffuserSVG(0, 18, .82)}${diffuserSVG(194, 18, .82)}${diffuserSVG(90, 4, .96)}</g></svg>`;
    case 'deo':
      return `<svg viewBox="0 0 220 220" aria-hidden="true">${spray}<g class="pm-float">${sprayBottleSVG(40, 6, 1)}</g></svg>`;
    case 'deo2':
      return `<svg viewBox="0 0 260 220" aria-hidden="true"><g class="pm-float">${sprayBottleSVG(10, 14, .92)}${sprayBottleSVG(118, 6, .96)}</g></svg>`;
    case 'pouch':
      return `<svg viewBox="0 0 220 220" aria-hidden="true"><g class="pm-float">${pouchSVG(40, 8, 1)}</g></svg>`;
    default:
      return `<svg viewBox="0 -60 240 250" aria-hidden="true">${mist}<g class="pm-float">${diffuserSVG(60, 0, 1)}</g></svg>`;
  }
}

/* ---------- shop page: every product, grouped by line ---------- */
const itemUrl = (p) => `/?view=item&p=${p.id}`;
const packPhotoSets = new Map();
const photosFor = (p, pet, plug, pack) => {
  if (!usesPet(p) && p.pets) pet = p.pets[0]; // no formula to choose: its photos sit under its own pet
  const base = (p.images && ((plug && p.images[`${pet}-${plug}`]) || p.images[pet])) || null;
  const lead = base && p.packImages && p.packImages[`${pet}-${Number(pack) || 1}`];
  if (!lead) return base;
  // a size with its own lead photo (e.g. 3 kits): that photo first, then the rest of the usual set
  const key = `${p.id}|${pet}|${plug || ''}|${pack}`;
  if (!packPhotoSets.has(key)) packPhotoSets.set(key, [lead, ...base.slice(1)]);
  return packPhotoSets.get(key);
};
const artFor = (p, pack) => (p.packs && packOf(p, pack).art) || p.art;
const cardMedia = (p, plug, pack, formula) => {
  const ph = photosFor(p, formula || petFor(p), plug || (p.plugs && preferredPlug()), pack);
  return ph ? `<img src="${ph[0].card || ph[0].large}" alt="" width="600" height="600" loading="lazy" decoding="async">` : productArt(artFor(p, pack));
};

// Listing cards (shop page and "You might also like") show the product only. Sizes, plug type, formula and
// subscriptions are chosen on the product's own page, so a product with choices gets a "Choose options"
// link there; one with nothing to choose (CalmMist) keeps a direct "Add to cart".
const hasOptions = (p) => Boolean(p.packs || p.plugs || p.subscribe || p.mix || p.kitPlan);
function productCard(p, i) {
  const pet = currentPet();
  return `
    <article class="product reveal ${p.badge === 'Best value' ? 'featured' : ''}" style="--rd:${i * 0.1}s" data-product="${p.id}">
      ${p.badge ? `<span class="badge">${p.badge}</span>` : ''}
      ${p.ribbon ? `<span class="card-ribbon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5 14.6 9l6 .6-4.5 4 1.3 5.9L12 16.4l-5.4 3.1 1.3-5.9-4.5-4 6-.6Z"/></svg>${p.ribbon}</span>` : ''}
      <a class="product-media ${photosFor(p, petFor(p), p.plugs && preferredPlug()) ? 'has-photo' : ''}" href="${itemUrl(p)}" tabindex="-1" aria-hidden="true">${cardMedia(p)}</a>
      <div class="product-body">
        <h3><a class="product-link" href="${itemUrl(p)}" data-name>${fullName(p)}</a></h3>
        ${cardRating(p)}
        <p class="desc">${p.desc}</p>
        <ul class="perks">${(PERKS[p.id] || p.includes).filter((t) => subLive(p) || !SUB_TEXT.test(t)).map((t) => `<li>${CHECK}<span>${t}</span></li>`).join('')}</ul>
        <div class="price-row">
          <span class="price">${hasOptions(p) ? '<small class="price-from">From</small> ' : ''}${money(fromPrice(p))}</span>${cardWas(p) ? `<s class="price-was">${money(cardWas(p))}</s>` : ''}
          ${cardSaving(p) ? `<span class="card-save">${cardSaving(p)}</span>` : ''}
        </div>
        ${hasOptions(p) ? `<a class="btn add-btn cta-buy cta-card" href="${itemUrl(p)}" aria-label="Choose options for ${p.name}"><span class="cta-label">Choose options</span>${ARROW}</a>` : `
        <button class="btn add-btn cta-buy cta-card" type="button" data-add="${p.id}">
          <span class="paws" aria-hidden="true"><i></i><i></i><i></i><i></i></span>
          <span class="cta-label">Add<span class="cta-long"> to cart</span></span><span class="cta-price">${money(packOf(p, 1).price)}</span>
        </button>`}
        <p class="card-assure">Free shipping · 30-day returns</p>
      </div>
    </article>`;
}

function renderShop() {
  $$('[data-line]').forEach((wrap) => {
    const items = PRODUCTS.filter((p) => p.group === wrap.dataset.line && !p.hidden && sellable(p));
    wrap.style.setProperty('--n', items.length);
    wrap.innerHTML = items.map(productCard).join('');
    // a product marked `wide` gets the full-width layout (only here on the shop page, not in "You might also like")
    $$('[data-product]', wrap).forEach((card) => card.classList.toggle('product-wide', Boolean(findProduct(card.dataset.product).wide)));
    wrap.classList.toggle('has-wide', items.some((p) => p.wide));
    window.FF?.observeReveals?.(wrap);
  });
  // links like product.html?p=refills jump to that section
  const want = new URLSearchParams(location.search).get('p');
  const target = want && document.getElementById(want);
  if (target) setTimeout(() => target.scrollIntoView({ block: 'start' }), 50);
}

/* ---------- shop page: "Not sure which one you need?" helper ---------- */
// Each answer points at one product (and a size, where that matters). The reasons reuse what the site
// already says about each product, so there is nothing new to keep true here.
const FINDER = [
  { key: 'home', label: (pet) => `A calmer ${pet} at home`, id: 'starter', why: () => 'Start here: one plug-in diffuser and 2 refills. Everything you need for one room, ready to plug in.' },
  { key: 'rooms', label: () => 'More than one room or floor', id: 'starter', pack: 2, why: () => 'One diffuser covers up to 700 sq ft, so use one per floor. Choose 1, 2 or 3 kits on the product page.' },
  { key: 'refill', label: () => 'I already have a CalmPod', id: 'refill', why: (p) => `Each refill lasts about 30 days and fits every FurrFlora diffuser.${subLive(p) ? ' Subscribe for a lower price on every delivery.' : ''}` },
  { key: 'both', label: () => 'I have cats and dogs', id: 'refill', pack: 3, why: () => 'The Calm Mix: 2 or 3 refills where you choose Feline or Canine for each one.' },
  { key: 'go', label: () => 'Travel, vet visits, new places', id: 'spray', why: (p) => p.desc },
];

function initFinder() {
  const root = $('[data-finder]');
  if (!root) return;
  const toggle = $('[data-finder-toggle]', root);
  const panel = $('[data-finder-panel]', root);
  const chips = $('[data-finder-chips]', root);
  const result = $('[data-finder-result]', root);
  let picked = null;
  const options = () => FINDER.filter((f) => (!f.pets || f.pets.includes(currentPet())) && sellable(findProduct(f.id)));
  const mixFor = (f) => (f.key === 'both' ? (currentPet() === 'dog' ? 'mix-1-2' : 'mix-2-1') : '');

  const draw = () => {
    const pet = currentPet();
    const list = options();
    const f = list.find((x) => x.key === picked);
    if (!f) picked = null;
    chips.innerHTML = list.map((x) => `<button type="button" class="finder-chip" aria-pressed="${x.key === picked}" data-finder-pick="${x.key}">${x.label(pet)}</button>`).join('');
    result.hidden = !f;
    if (!f) { result.innerHTML = ''; return; }
    const p = findProduct(f.id);
    const k = packOf(p, f.pack);
    const mix = mixFor(f);
    const ph = photosFor(p, mix || petFor(p), p.plugs && preferredPlug(), f.pack);
    result.innerHTML = `
      <div class="finder-shot">${ph ? `<img src="${ph[0].thumb}" alt="" width="84" height="84" decoding="async">` : productArt(artFor(p, f.pack))}</div>
      <div>
        <p class="finder-name">${fullName(p, pet, mix || undefined)}</p>
        <p class="finder-why">${f.why(p)}</p>
        <p class="finder-price">${p.packs && k.label ? `${k.label} · ` : ''}${money(k.price)}${k.compareAt ? `<s>${money(k.compareAt)}</s>` : ''}</p>
      </div>
      <div class="finder-actions">
        <a class="btn btn-primary" href="${itemUrl(p)}${f.pack ? `&pack=${f.pack}` : ''}">View product</a>
      </div>`;
  };

  if (toggle) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
    if (open) draw();
  });

  root.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-finder-pick]');
    if (chip) {
      picked = chip.dataset.finderPick;
      draw();
      $(`[data-finder-pick="${picked}"]`, chips)?.focus({ preventScroll: true }); // the chips were rebuilt
    }
  });

  document.addEventListener('ff:petchange', () => { if (!panel.hidden) draw(); });
  if (!panel.hidden) draw(); // the home page's helper is always open
}

/* ---------- cart state ---------- */
let cart = [];
try { cart = JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; } catch { cart = []; }
cart.forEach((l) => { if (l.id === 'refill' && !l.pack) l.pack = 3; });
cart.forEach((l) => { if (l.id === REFILL_PLAN_ID) { l.id = 'refill'; l.pack = Math.min(3, Math.max(1, Math.round((l.pack || 2) / 2))); } }); // old delayed kit plan lines // the old Refill 3-Pack is now the 3-refill size
cart.forEach((l) => { const m = MERGED[l.id]; if (m) { l.id = m.id; l.pack = m.pack; } }); // e.g. the old Calm Home Bundle is now the 3-kit Starter Kit
cart = cart.filter((l) => findProduct(l.id) && l.pet !== 'mix' && (!mixCounts(l.pet) || findProduct(l.id).variants[l.pet] !== undefined)); // drop anything no longer sold
cart.forEach((l) => { const p = findProduct(l.id); if (p.plugs && !PLUGS[l.plug]) l.plug = preferredPlug(); }); // older lines: add a plug
const save = () => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(cart)); } catch { /* private mode */ } };

const lineKey = (l) => [l.id, l.pet || '-', l.plug || '-', l.pack || 1, l.plan || 'once'].join('|');
const linePrice = (l) => {
  const p = findProduct(l.id);
  const k = packOf(p, l.pack, l.pet, l.plug);
  return l.plan ? subPriceOf(p, k) : k.price;
}
// what is paid at checkout: a kit's refill subscription (startsAfter) is charged later, when it ships
const todayPrice = (l) => (findProduct(l.id).startsAfter ? 0 : linePrice(l));
const subtotal = () => cart.reduce((s, l) => s + todayPrice(l) * l.qty, 0);
const count = () => cart.reduce((s, l) => s + l.qty, 0);
const lineMeta = (l) => {
  const p = findProduct(l.id);
  const parts = [];
  if (p.packs && usesPet(p) && (l.pack || 1) > 1) parts.push(packOf(p, l.pack).label);
  if (usesPet(p)) parts.push(mixCounts(l.pet) ? `The Calm Mix (${mixText(l.pet)} refills)` : `${petLabel(l.pet)} Formula`);
  else parts.push(packOf(p, l.pack).includes[0]); // e.g. "2 × 250 ml refills"
  if (l.plug) parts.push(`${l.plug} plug`);
  if (l.plan) parts.push(`every ${l.plan} days`);
  return parts.join(' · ');
};

function addToCart(id, plan, qty = 1, pet, plug, pack) {
  const p = findProduct(id);
  const line = { id, pet: usesPet(p) ? petFor(p, pet || currentPet()) : null, plug: p.plugs ? (plug || preferredPlug()) : null, pack: p.packs ? Number(pack || 1) : null, plan: plan || null, qty };
  const existing = cart.find((l) => lineKey(l) === lineKey(line));
  if (existing) existing.qty += qty; else cart.push(line);
  save(); renderCart(true);
}

/* ---------- cart UI ---------- */
const drawer = $('[data-cart]');
const overlay = $('[data-cart-overlay]');
let lastFocus = null;

// "Add calm on the go?": CalmMist for trips, when the cart has CalmPod items but no CalmMist yet (2026-10-21)
function cartUpsellHTML(size = 56) {
  const pod = cart.find((l) => l.id === 'starter' || l.id === 'refill');
  const mist = findProduct('spray');
  const upPet = pod && (pod.pet === 'cat' || pod.pet === 'dog' ? pod.pet : currentPet());
  if (!pod || !mist || cart.some((l) => l.id === 'spray') || packOf(mist, 1, upPet).available === false) return '';
  const k = packOf(mist, 1, upPet);
  const ph = photosFor(mist, upPet);
  return `
      <li class="cart-upsell">
        <div class="cart-upsell-shot">${ph ? `<img src="${ph[0].thumb}" alt="" width="${size}" height="${size}" loading="lazy" decoding="async">` : productArt(artFor(mist))}</div>
        <div>
          <p class="cart-upsell-title">Add calm on the go?</p>
          <p class="cart-upsell-why">${fullName(mist, upPet)}: for carriers, vet visits and travel.</p>
          <p class="cart-upsell-price">${money(k.price)}${k.compareAt > k.price ? ` <s>${money(k.compareAt)}</s>` : ''}</p>
        </div>
        <button class="btn btn-small btn-primary" type="button" data-upsell-add="${upPet}" aria-label="Add ${fullName(mist, upPet)} to cart">Add</button>
      </li>`;
}
// spell out every recurring charge, so nobody is surprised later
const recurringHTML = (subs) => (subs.length ? `<p class="cart-recurring-title">Your subscriptions</p><ul>${subs.map((l) => {
  const p = findProduct(l.id);
  const when = p.startsAfter ? 'nothing today; it starts once the kit’s own refills run out' : 'starting today';
  return `<li><strong>${money(linePrice(l) * l.qty)} every ${l.plan} days</strong> for ${fullName(p, l.pet)}, ${when}. Skip or cancel anytime.</li>`;
}).join('')}</ul><a class="cart-recurring-link" href="/?view=policies#subscriptions">How subscriptions work</a>` : '');
// delivery window: 5 to 8 business days from the order, shipping included (owner, 2026-10-21)
const deliveryWindow = () => {
  const addWorkdays = (n) => { const d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n -= 1; } return d; };
  const day = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  return `${day(addWorkdays(5))} – ${day(addWorkdays(8))}`;
};

/* ---------- the full cart page (/cart, /cart in the theme; 2026-10-21) ---------- */
function renderCartPage() {
  const root = $('[data-cart-page]');
  if (!root) return;
  const empty = cart.length === 0;
  root.hidden = empty;
  $('[data-cp-empty]').hidden = !empty;
  if (empty) return;
  $('[data-cp-lines]').innerHTML = cart.map((l, i) => {
    const p = findProduct(l.id);
    const ph = photosFor(p, l.pet, l.plug, l.pack);
    const k = packOf(p, l.pack, l.pet, l.plug);
    const was = l.plan ? regularPrice(k) : k.compareAt;
    const href = `${itemUrl(p)}${(l.pack || 1) > 1 ? `&pack=${l.pack}` : ''}`;
    return `
      <li class="cp-line">
        <a class="cp-thumb" href="${href}" tabindex="-1" aria-hidden="true">${ph ? `<img src="${ph[0].thumb}" alt="" width="120" height="120" decoding="async">` : productArt(artFor(p, l.pack))}</a>
        <div class="cp-info">
          <a class="cp-name" href="${href}">${fullName(p, l.pet)}</a>
          <p class="cp-meta">${lineMeta(l)}</p>
          ${l.plan ? `<p class="cp-plan">Subscription · ${money(linePrice(l) * l.qty)} every ${l.plan} days</p>` : ''}
        </div>
        <p class="cp-price">${money(todayPrice(l) * l.qty)}${was && was > linePrice(l) + 0.004 ? `<s>${money(was * l.qty)}</s>` : ''}</p>
        <div class="cp-actions">
            <div class="qty">
              <button type="button" aria-label="Decrease quantity of ${fullName(p, l.pet)}" data-qty="${i}" data-delta="-1">−</button>
              <span aria-live="polite">${l.qty}</span>
              <button type="button" aria-label="Increase quantity of ${fullName(p, l.pet)}" data-qty="${i}" data-delta="1">+</button>
            </div>
            <button class="line-remove" type="button" data-remove="${i}">Remove</button>
        </div>
      </li>`;
  }).join('') + cartUpsellHTML(72);
  const subs = cart.filter((l) => l.plan);
  const box = $('[data-cp-subs]');
  box.hidden = !subs.length;
  box.innerHTML = recurringHTML(subs);
  const n = count();
  $('[data-cp-count]').textContent = `(${n} item${n === 1 ? '' : 's'})`;
  $('[data-cp-subtotal]').textContent = money(subtotal());
  $('[data-cp-total]').textContent = money(subtotal());
  const dc = welcomeDiscount();
  $('[data-cp-code]').hidden = !dc;
  if (dc) $('[data-cp-code-text]').textContent = `${dc} · ${window.ffWelcomeCode?.percent || 15}% off one-time items, applied at checkout`;
  $('[data-cp-eta]').textContent = deliveryWindow();
  $('[data-cp-mbar-total]').textContent = money(subtotal());
  // phones: a checkout bar along the bottom while the summary's own button is off screen
  const bar = $('[data-cp-mbar]');
  if (bar && !bar.dataset.watched && 'IntersectionObserver' in window) {
    bar.dataset.watched = '1';
    new IntersectionObserver(([en]) => bar.classList.toggle('show', !en.isIntersecting && !$('[data-cart-page]').hidden)).observe($('.cp-checkout'));
  }
}

function renderCart(bump = false) {
  const n = count();
  $$('[data-cart-count]').forEach((el) => {
    el.textContent = n;
    el.classList.toggle('has-items', n > 0);
    if (bump) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  });
  $$('[data-cart-open]').forEach((b) => b.setAttribute('aria-label', `Open cart, ${n} item${n === 1 ? '' : 's'}`));

  const list = $('[data-cart-lines]');
  if (!list) return;
  list.innerHTML = cart.map((l, i) => {
    const p = findProduct(l.id);
    return `
      <li class="line">
        <div class="line-thumb">${photosFor(p, l.pet, l.plug, l.pack) ? `<img src="${photosFor(p, l.pet, l.plug, l.pack)[0].thumb}" alt="" width="64" height="64" loading="lazy" decoding="async">` : productArt(artFor(p, l.pack))}</div>
        <div>
          <div class="line-title">${fullName(p, l.pet)}</div>
          <div class="line-meta">${lineMeta(l)}</div>
          <div class="qty">
            <button type="button" aria-label="Decrease quantity of ${fullName(p, l.pet)}" data-qty="${i}" data-delta="-1">−</button>
            <span aria-live="polite">${l.qty}</span>
            <button type="button" aria-label="Increase quantity of ${fullName(p, l.pet)}" data-qty="${i}" data-delta="1">+</button>
          </div>
        </div>
        <div class="line-price">${money(todayPrice(l) * l.qty)}${p.startsAfter ? '<small class="line-today">today</small>' : ''}
          <button class="line-remove" type="button" data-remove="${i}">Remove</button>
        </div>
      </li>`;
  }).join('');

  list.insertAdjacentHTML('beforeend', cartUpsellHTML());

  const empty = cart.length === 0;
  $('[data-cart-empty]').hidden = !empty;
  list.hidden = empty;
  $('.drawer-foot').hidden = empty;
  $('[data-cart-subtotal]').textContent = money(subtotal());
  // spell out every recurring charge, so nobody is surprised later
  const subs = cart.filter((l) => l.plan);
  let rec = $('[data-cart-recurring]');
  if (!rec) { rec = document.createElement('div'); rec.className = 'cart-recurring'; rec.dataset.cartRecurring = ''; $('.drawer-foot').prepend(rec); }
  rec.hidden = !subs.length;
  rec.innerHTML = recurringHTML(subs);

  const st = subtotal();
  const dc = welcomeDiscount();
  $('[data-ship-text]').innerHTML = '<strong>Free shipping</strong> on every order' + (dc ? `<br>Welcome code <strong>${dc}</strong> (${window.ffWelcomeCode?.percent || 15}% off) is added at checkout` : '');
  renderCartPage();
}

document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-upsell-add]');
  if (!b) return;
  addToCart('spray', null, 1, b.dataset.upsellAdd);
  toast(`${fullName(findProduct('spray'), b.dataset.upsellAdd)} added to cart`);
});

/* ---------- after a kit is added on its own: offer refills on subscription and CalmMist (owner, 2026-10-21) ---------- */
// Opens when "Kit only" goes into the cart. Each offer only shows if it can be bought and isn't in the cart yet;
// with neither left, nothing opens. Subscription charges are spelled out, like everywhere else.
function kitUpsell({ pet, pack = 1, qty = 1, from }) {
  pet = pet === 'dog' ? 'dog' : 'cat';
  const rp = findProduct(KIT_REFILLS), mist = findProduct('spray'), kit = findProduct('starter');
  const r = kitRefills(pack);
  const showSub = rp && subAt(rp, pet, r) && packOf(rp, r, pet).available !== false && !cart.some((l) => l.id === KIT_REFILLS && l.plan);
  const showMist = mist && packOf(mist, 1, pet).available !== false && !cart.some((l) => l.id === 'spray');
  if (!showSub && !showMist) return false;
  $('[data-upsell]')?.remove();
  const shot = (ph, prod) => (ph ? `<img src="${ph[0].thumb}" alt="" width="72" height="72" decoding="async">` : productArt(artFor(prod)));
  const rk = rp && packOf(rp, r, pet), mk = mist && packOf(mist, 1, pet);
  const subOffer = !showSub ? '' : `
      <div class="upsell-offer" data-offer="sub">
        <div class="upsell-shot">${shot(photosFor(rp, pet, null, r), rp)}</div>
        <div class="upsell-body">
          <p class="upsell-name">Refill subscription</p>
          <p class="upsell-why">Never run out of your pet’s calm. ${r * qty} ${r * qty > 1 ? 'refills ship' : 'refill ships'} with your kit, then more arrive before you run out. Skip, change dates or cancel anytime.</p>
          <label class="upsell-freq"><span>Deliver every</span>
            <select data-upsell-freq><option value="30" selected>30 days</option><option value="60">60 days</option><option value="90">90 days</option></select>
          </label>
          <p class="upsell-price"><strong>${money(subPriceOf(rp, rk) * qty)}</strong>${regularPrice(rk) > subPriceOf(rp, rk) ? ` <s>${money(regularPrice(rk) * qty)}</s>` : ''} a delivery</p>
          <p class="upsell-charge" data-upsell-charge></p>
        </div>
        <button class="btn btn-primary upsell-add" type="button" data-upsell-sub>Add subscription</button>
      </div>`;
  const mistOffer = !showMist ? '' : `
      <div class="upsell-offer" data-offer="mist">
        <div class="upsell-shot">${shot(photosFor(mist, pet), mist)}</div>
        <div class="upsell-body">
          <p class="upsell-name">${fullName(mist, pet)}</p>
          <p class="upsell-why">Calm on the go: for carriers, vet visits, car journeys and new places. No plug needed.</p>
          <p class="upsell-price"><strong>${money(mk.price)}</strong>${mk.compareAt > mk.price ? ` <s>${money(mk.compareAt)}</s>` : ''}</p>
        </div>
        <button class="btn btn-primary upsell-add" type="button" data-upsell-mist>Add CalmMist</button>
      </div>`;
  const wrap = document.createElement('div');
  wrap.className = 'upsell-wrap';
  wrap.dataset.upsell = '';
  wrap.innerHTML = `
    <div class="upsell-overlay" data-upsell-close></div>
    <div class="upsell" role="dialog" aria-modal="true" aria-labelledby="upsell-title">
      <button class="icon-btn upsell-x" type="button" aria-label="Close" data-upsell-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>
      <p class="upsell-added"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>${fullName(kit, pet)}${pack > 1 ? ` × ${pack}` : ''} added to your cart</p>
      <h2 class="upsell-title" id="upsell-title">Complete <em>their calm</em></h2>
      <div class="upsell-offers">${subOffer}${mistOffer}</div>
      <div class="upsell-foot">
        <button class="btn btn-ghost" type="button" data-upsell-cart>View cart</button>
        <button class="upsell-skip" type="button" data-upsell-close>No thanks, continue shopping</button>
      </div>
    </div>`;
  document.body.appendChild(wrap);
  const freq = $('[data-upsell-freq]', wrap);
  const charge = () => {
    const c = $('[data-upsell-charge]', wrap);
    if (c) c.textContent = `You’ll be charged ${money(subPriceOf(rp, rk) * qty)} today, then ${money(subPriceOf(rp, rk) * qty)} every ${freq.value} days until you cancel.`;
  };
  if (freq) { freq.addEventListener('change', charge); charge(); }
  const done = (btn, label) => { btn.disabled = true; btn.classList.add('is-added'); btn.textContent = label; btn.closest('.upsell-offer').classList.add('is-added'); };
  const close = () => {
    wrap.classList.remove('open');
    document.removeEventListener('keydown', onKey);
    document.body.style.overflow = '';
    setTimeout(() => wrap.remove(), 300);
    if (from && document.contains(from)) from.focus({ preventScroll: true });
  };
  const onKey = (e) => {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return; // keep focus inside the popup
    const f = $$('button:not([disabled]), select', wrap).filter((el) => el.offsetParent);
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  };
  wrap.addEventListener('click', (e) => {
    if (e.target.closest('[data-upsell-close]')) { close(); return; }
    if (e.target.closest('[data-upsell-cart]')) { close(); openCart(); return; }
    const sb = e.target.closest('[data-upsell-sub]');
    if (sb) { addToCart(KIT_REFILLS, freq.value, qty, pet, undefined, r); done(sb, 'Added ✓'); return; }
    const mb = e.target.closest('[data-upsell-mist]');
    if (mb) { addToCart('spray', null, 1, pet); done(mb, 'Added ✓'); }
  });
  document.addEventListener('keydown', onKey);
  document.body.style.overflow = 'hidden';
  requestAnimationFrame(() => { wrap.classList.add('open'); $('.upsell-add', wrap)?.focus({ preventScroll: true }); });
  return true;
}

/* ---------- payment logos (2026-10-21) ---------- */
// In the Shopify theme the layout holds Shopify's own logos for every payment method the store has
// switched on (<template id="ff-pay-icons">), so they stay right when methods change. The plain website
// shows simple drawn badges instead, for what the store accepted on 2026-10-21.
const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
// a speaker button on a video (owner, 2026-10-21): videos start silent (browsers only autoplay muted ones);
// tapping it turns the sound on, and any other video playing with sound is muted
const SOUND_OFF = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4Z"/><path d="m16 9.5 5 5M21 9.5l-5 5"/></svg>';
const SOUND_ON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4Z"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/></svg>';
function addSoundButton(video, holder) {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'pv-sound';
  const show = () => { b.innerHTML = video.muted ? SOUND_OFF : SOUND_ON; b.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off'); b.setAttribute('aria-pressed', String(!video.muted)); };
  b.addEventListener('click', (e) => {
    e.stopPropagation();
    const on = video.muted;
    if (on) $$('video').forEach((o) => { if (o !== video && !o.muted) { o.muted = true; o.dispatchEvent(new Event('volumechange')); } });
    video.muted = !on;
    if (on) { holder.classList.remove('is-held'); video.play().catch(() => {}); }
  });
  video.addEventListener('volumechange', show);
  show();
  holder.appendChild(b);
}
const PAY_FRAME = (fill = '#fff', stroke = '#D9D9D9') => `<rect x=".5" y=".5" width="37" height="23" rx="3" fill="${fill}" stroke="${stroke}"/>`;
const PAY_TEXT = (x, y, size, fill, text, extra = '') => `<text x="${x}" y="${y}" font-family="Arial, Helvetica, sans-serif" font-size="${size}" font-weight="700" fill="${fill}" text-anchor="middle" ${extra}>${text}</text>`;
const PAY_METHODS = [ // the owner's choice and order (2026-10-21)
  ['American Express', PAY_FRAME('#1F72CD', '#1F72CD') + PAY_TEXT(19, 15.4, 8.6, '#fff', 'AMEX', 'font-weight="900" letter-spacing=".4"')],
  ['Mastercard', PAY_FRAME() + '<circle cx="15" cy="12" r="7" fill="#EB001B"/><circle cx="23" cy="12" r="7" fill="#F79E1B"/><path d="M19 6.26A7 7 0 0 1 19 17.74 7 7 0 0 1 19 6.26Z" fill="#FF5F00"/>'],
  ['Visa', PAY_FRAME() + PAY_TEXT(19, 16, 10.5, '#1434CB', 'VISA', 'font-style="italic" font-weight="900" letter-spacing=".3"')],
  ['Apple Pay', PAY_FRAME('#fff', '#000') + '<path d="M12.3 7.9c.4-.5.7-1.2.6-1.9-.6 0-1.3.4-1.7.9-.4.4-.7 1.1-.6 1.8.7 0 1.3-.4 1.7-.8Zm.6 1c-.9 0-1.7.5-2.1.5s-1.1-.5-1.9-.5c-1 0-1.9.6-2.4 1.4-1 1.8-.3 4.4.7 5.8.5.7 1 1.4 1.8 1.4.7 0 1-.5 1.9-.5s1.1.5 1.9.5c.8 0 1.3-.7 1.8-1.4.5-.8.8-1.6.8-1.6s-1.5-.6-1.5-2.3c0-1.4 1.2-2.1 1.2-2.1-.7-1-1.7-1.1-2.1-1.1Z" fill="#000"/>' + PAY_TEXT(25, 15.6, 9, '#000', 'Pay', 'font-weight="600"')],
  ['Google Pay', PAY_FRAME() + PAY_TEXT(11.5, 15.8, 10, '#4285F4', 'G', 'font-weight="800"') + PAY_TEXT(23.5, 15.6, 9, '#5F6368', 'Pay', 'font-weight="600"')],
  ['Klarna', PAY_FRAME('#FFB3C7', '#FFB3C7') + PAY_TEXT(19, 15.6, 8.6, '#0B051D', 'Klarna.', 'font-weight="800"')],
];
function fillPayIcons() {
  const tpl = document.getElementById('ff-pay-icons');
  const live = tpl && tpl.content && tpl.content.querySelector('svg');
  $$('[data-pay-icons]').forEach((box) => {
    if (live) box.replaceChildren(tpl.content.cloneNode(true));
    else box.innerHTML = PAY_METHODS.map(([name, art]) => `<svg viewBox="0 0 38 24" width="38" height="24" role="img" aria-label="${name}"><title>${name}</title>${art}</svg>`).join('');
  });
}

function openCart() {
  lastFocus = document.activeElement;
  drawer.hidden = false; overlay.hidden = false;
  requestAnimationFrame(() => { drawer.classList.add('open'); overlay.classList.add('open'); });
  document.body.style.overflow = 'hidden';
  setTimeout(() => $('[data-cart-close]', drawer)?.focus(), 60);
}
function closeCart() {
  drawer.classList.remove('open'); overlay.classList.remove('open');
  document.body.style.overflow = '';
  setTimeout(() => { drawer.hidden = true; overlay.hidden = true; }, 560);
  lastFocus?.focus?.();
}

// the welcome popup's discount code, once the visitor has signed up (applied at Shopify checkout)
document.addEventListener("ff:discount", () => renderCart());
function welcomeDiscount() { try { return localStorage.getItem('furrflora-discount'); } catch { return null; } }

function toast(msg) {
  const t = $('[data-toast]');
  t.textContent = msg; t.classList.add('show');
  clearTimeout(toast._t); toast._t = setTimeout(() => t.classList.remove('show'), 2600);
}

/* ---------- Shopify checkout ---------- */
async function checkout(pressed) {
  const btn = pressed || $('[data-checkout]');
  const msg = btn.parentElement.querySelector('[data-checkout-msg]') || $('[data-checkout-msg]');
  const label = btn.innerHTML;
  const far = !btn.parentElement.querySelector('[data-checkout-msg]'); // e.g. the cart page's phone bar
  const show = () => { if (far) msg.scrollIntoView({ block: 'center', behavior: 'smooth' }); };
  msg.classList.remove('error');

  if (!checkoutOpen()) {
    // closed until launch: SHOPIFY_CONFIG.open is false (or the store details are missing)
    msg.textContent = 'Checkout isn’t open yet. We’re launching soon.';
    show();
    return;
  }

  const missing = [];
  const lines = cart.map((l) => {
    const p = findProduct(l.id);
    const kits = (l.pack || 1) > 1 ? `-${l.pack}` : '';
    const merchandiseId = variantIdFor(p, l.pet, l.plug, l.pack);
    if (!merchandiseId) missing.push(usesPet(p) ? `${p.name}${kits ? ` × ${l.pack}` : ''} (${formulaLabel(l.pet)}${l.plug ? `, ${l.plug} plug` : ''})` : `${p.name}${kits ? ` × ${l.pack}` : ''}`);
    const line = { merchandiseId, quantity: l.qty };
    if (l.plan) {
      const sp = planIdFor(p, l.pet, l.pack, l.plan);
      if (!sp) missing.push(`${p.name} subscription plan (${l.plan} days)`);
      line.sellingPlanId = sp;
    }
    return line;
  });
  if (missing.length) {
    msg.classList.add('error');
    msg.textContent = 'Checkout isn’t set up yet for: ' + missing.join(', '); // missing variant or selling-plan IDs
    show();
    return;
  }

  btn.disabled = true; btn.textContent = 'Heading to checkout…';
  try {
    if (window.FF_THEME) {
      // running as a Shopify theme: put the items in the store's own cart, then open its checkout
      const num = (gid) => Number(String(gid).split('/').pop());
      const items = lines.map((l) => ({ id: num(l.merchandiseId), quantity: l.quantity, ...(l.sellingPlanId ? { selling_plan: num(l.sellingPlanId) } : {}) }));
      await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
      const added = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!added.ok) throw new Error((await added.json().catch(() => ({}))).description || 'Could not add to cart');
      window.location.href = '/checkout' + (welcomeDiscount() ? `?discount=${encodeURIComponent(welcomeDiscount())}` : '');
      return;
    }
    const res = await fetch(`https://${SHOPIFY_CONFIG.shopDomain}/api/${SHOPIFY_CONFIG.apiVersion}/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_CONFIG.storefrontToken,
      },
      body: JSON.stringify({
        query: `mutation cartCreate($input: CartInput!) {
          cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } }
        }`,
        variables: { input: { lines, ...(welcomeDiscount() ? { discountCodes: [welcomeDiscount()] } : {}) } },
      }),
    });
    const json = await res.json();
    const errs = json.errors || json.data?.cartCreate?.userErrors;
    const url = json.data?.cartCreate?.cart?.checkoutUrl;
    if (!url) throw new Error(errs?.[0]?.message || 'Could not create cart');
    window.location.href = url;
  } catch (e) {
    msg.classList.add('error');
    msg.textContent = 'Checkout is unavailable right now. Please try again. (' + e.message + ')';
    btn.disabled = false; btn.innerHTML = label;
  }
}

/* ---------- cart events ---------- */
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-cart-open]')) { openCart(); return; }
  if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { closeCart(); return; }

  const q = e.target.closest('[data-qty]');
  if (q) {
    const l = cart[+q.dataset.qty];
    l.qty += +q.dataset.delta;
    if (l.qty <= 0) cart.splice(+q.dataset.qty, 1);
    save(); renderCart(); return;
  }
  const r = e.target.closest('[data-remove]');
  if (r) { cart.splice(+r.dataset.remove, 1); save(); renderCart(); $('[data-cart-close]', drawer)?.focus(); return; }
  const go = e.target.closest('[data-checkout]');
  if (go) checkout(go);
});

document.addEventListener('keydown', (e) => {
  if (drawer.hidden) return;
  if (e.key === 'Escape') closeCart();
  if (e.key === 'Tab') {
    const f = $$('button:not([disabled]), a[href], select, input', drawer).filter((el) => !el.closest('[hidden]'));
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
});

/* ---------- add to cart from a product card ---------- */
document.addEventListener('click', (e) => {
  const add = e.target.closest('[data-add]');
  if (!add) return;
  const card = add.closest('[data-product]');
  const p = findProduct(add.dataset.add);
  const sub = $('input[value="sub"]', card);
  const plan = sub && sub.checked ? $('[data-freq]', card).value : null;
  const mix = $('[data-mix-select]', card)?.value || undefined;
  const plug = $('[data-plug-select]', card)?.value || undefined;
  const pack = packOf(p, $('[data-pack]:checked', card)?.value);
  addToCart(p.id, plan, 1, mix, plug, pack.n);
  const refillEvery = p.kitPlan && kitPlanChoice($('[data-kit-plan]', card));
  if (refillEvery) addToCart(KIT_REFILLS, refillEvery, 1, mix || currentPet(), undefined, kitRefills(pack.n));
  add.classList.remove('added'); void add.offsetWidth; add.classList.add('added');
  const extras = [mixCounts(mix) ? shortFormula(mix) : '', plug ? `${plug} plug` : ''].filter(Boolean).join(', ');
  toast(`${fullName(p, mix || currentPet())}${pack.n > 1 ? ` × ${pack.n}` : ''}${extras ? ` (${extras})` : ''}${refillEvery ? ' + refill subscription' : ''} added to cart`);
});

// keep the "Feline / Canine Formula" labels in step with the Cat / Dog switch
document.addEventListener('ff:petchange', () => {
  // names follow the pet ("for Cats" / "for Dogs"), and cards with product photos swap them
  $$('[data-product]').forEach((card) => {
    const p = findProduct(card.dataset.product);
    const nm = $('[data-name]', card);
    if (nm) nm.textContent = fullName(p, $('[data-mix-select]', card)?.value || currentPet());
    // prices can differ by pet in the store (e.g. cat and dog refills), so refresh them too
    const priceEl = $('.price-row .price', card);
    if (priceEl) priceEl.innerHTML = `${hasOptions(p) ? '<small class="price-from">From</small> ' : ''}${money(fromPrice(p))}`;
    const wasEl = $('.price-row .price-was', card);
    if (wasEl && cardWas(p)) wasEl.textContent = money(cardWas(p));
    const saveEl = $('.card-save', card);
    if (saveEl) saveEl.innerHTML = cardSaving(p);
    const ctaPrice = $('.cta-price', card);
    if (ctaPrice) ctaPrice.textContent = money(packOf(p, 1).price);
    if (!p.images || $('[data-mix-select]', card)?.value) return; // a chosen Calm Mix keeps its own photo
    const m = $('.product-media', card);
    const plug = $('[data-plug-select]', card)?.value;
    const pack = $('[data-pack]:checked', card)?.value;
    m.innerHTML = cardMedia(p, plug, pack);
    m.dataset.shot = `${petFor(p)}|${plug || ''}|${Number(pack) || 1}`;
    m.dataset.formula = petFor(p);
    m.classList.toggle('has-photo', Boolean(photosFor(p, petFor(p), plug, pack)));
  });
  $$('[data-formula-label]').forEach((el) => {
    if (!el.closest('[data-product]')?.querySelector('[data-mix-select]')?.value) el.textContent = `${petLabel(currentPet())} Formula`;
  });
});

/* ---------- individual product page: /?view=item&p=<product id> ---------- */
function initItemPage() {
  const root = $('[data-item]');
  if (!root) return;
  const params = new URLSearchParams(location.search);
  const wanted = params.get('p');
  // old links to merged products open the matching size; hidden items (the refill subscription) open the Starter Kit
  const p = findProduct(MERGED[wanted] ? MERGED[wanted].id : findProduct(wanted)?.hidden ? 'starter' : wanted);
  if (!p) {
    $('[data-pdp-title]').textContent = 'Product not found';
    $('[data-pdp-lede]').innerHTML = 'Sorry, we couldn’t find that product. <a href="/collections/all">Browse the shop</a>.';
    $$('[data-pdp-buy-ui], .pdp-field, [data-pdp-chip], .related').forEach((el) => { el.hidden = true; });
    $('[data-crumb-name]').textContent = 'Not found';
    return;
  }
  if (!sellable(p)) {
    // in the store but not on sale yet (e.g. not added to Shopify)
    $('[data-pdp-title]').textContent = fullName(p);
    $('[data-pdp-lede]').innerHTML = 'Coming soon. <a href="/collections/all">See what’s available now</a>.';
    $$('[data-pdp-buy-ui], .pdp-field, [data-pdp-chip]').forEach((el) => { el.hidden = true; });
    $('[data-crumb-name]').textContent = fullName(p);
    return;
  }
  const g = GROUPS[p.group];
  const pdp = $('[data-pdp]', root);
  const state = { qty: 1, formula: currentPet(), pack: MERGED[wanted] ? MERGED[wanted].pack : Number(params.get('pack')) || 1 };
  if (!p.packs || !p.packs.some((x) => x.n === state.pack)) state.pack = p.packs ? p.packs[0].n : 1; // only sizes this product has

  // page text
  document.title = fullName(p).startsWith('FurrFlora') ? fullName(p) : `${fullName(p)} — FurrFlora`;
  $('meta[name="description"]')?.setAttribute('content', `${p.name}: ${p.desc} ${g.lede}`);
  // search engines and link previews: this product's own address, title, photo and price
  const pageUrl = `${location.origin}${location.pathname}?p=${p.id}`;
  const setMeta = (prop, content) => {
    let m = $(`meta[property="${prop}"]`);
    if (!m) { m = document.createElement('meta'); m.setAttribute('property', prop); document.head.appendChild(m); }
    m.setAttribute('content', content);
  };
  const canonical = $('link[rel="canonical"]') || document.head.appendChild(Object.assign(document.createElement('link'), { rel: 'canonical' }));
  canonical.href = pageUrl;
  const productData = document.head.appendChild(Object.assign(document.createElement('script'), { type: 'application/ld+json' }));
  // whose photos to show: the pet, or the Calm Mix combination built on this page (`currentFormula` is defined further down)
  const photoKey = () => (p.mix && state.formula === 'mix' && p.images[currentFormula()] ? currentFormula() : petFor(p));
  const shareTags = (shown) => {
    const photos = photosFor(p, photoKey(), p.plugs && (state.plug || preferredPlug()), state.pack);
    const image = new URL(photos ? photos[0].large : FF_A + 'share.jpg', location.href).href;
    const description = `${p.desc} ${g.lede}`;
    setMeta('og:title', shown); setMeta('og:description', description); setMeta('og:url', pageUrl); setMeta('og:image', image); setMeta('og:type', 'product');
    productData.textContent = JSON.stringify({
      '@context': 'https://schema.org', '@type': 'Product', name: shown, description, image,
      brand: { '@type': 'Brand', name: 'FurrFlora' },
      offers: { '@type': 'Offer', url: pageUrl, price: packOf(p, state.pack).price.toFixed(2), priceCurrency: CURRENCY },
      ...(rating ? {
        aggregateRating: { '@type': 'AggregateRating', ratingValue: rating.avg.toFixed(1), reviewCount: rating.count, bestRating: 5 },
        review: reviewsFor(p).map((r) => ({ '@type': 'Review', author: { '@type': 'Person', name: r.name }, reviewRating: { '@type': 'Rating', ratingValue: r.stars, bestRating: 5 }, reviewBody: r.text })),
      } : {}),
    });
  };
  $('[data-crumb-line]').textContent = g.title;
  $('[data-crumb-line]').href = `/collections/all#${p.group}`;
  $('[data-crumb-name]').textContent = fullName(p);
  $('[data-pdp-eyebrow]').textContent = g.eyebrow;
  $('[data-pdp-title]').textContent = fullName(p);
  // CalmPod pages (kit and refills): the owner's "Vet and behaviorist recommended" (2026-10-18) in place of "Secure checkout"
  const isCalmPod = REVIEW_LINE_OF[p.id] === 'calmpod';
  $('[data-assure-vet]')?.toggleAttribute('hidden', !isCalmPod);
  $('[data-assure-checkout]')?.toggleAttribute('hidden', isCalmPod);
  // questions and "What to expect" steps are written per product line (data-for="calmpod" / "calmmist" / "all")
  const lineKey = REVIEW_LINE_OF[p.id];
  $$('[data-pdp-faq] [data-for], [data-pdp-expect] [data-for]').forEach((el) => { el.hidden = !(el.dataset.for === 'all' || el.dataset.for === lineKey); });
  $$('[data-pdp-faq], [data-pdp-expect]').forEach((box) => { box.hidden = !box.querySelector('[data-for]:not([hidden])'); });
  const faqs = $$('[data-pdp-faq] details');
  faqs.forEach((d) => d.addEventListener('toggle', () => { if (d.open) faqs.forEach((o) => { if (o !== d) o.open = false; }); }));
  // estimated delivery: 5 to 8 business days from the order, shipping included (owner, 2026-10-21, matching checkout)
  const eta = $('[data-pdp-eta]');
  if (eta) {
    const addWorkdays = (from, n) => { const d = new Date(from); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n -= 1; } return d; };
    const day = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    $('[data-eta-dates]', eta).textContent = `${day(addWorkdays(new Date(), 5))} – ${day(addWorkdays(new Date(), 8))}`;
    eta.hidden = false;
  }
  // phones: the highlight tiles move below the buy button, so the name, stars and price sit on the first screen
  const tiles = $('[data-pdp-points]');
  const tilesHome = tiles?.parentElement;
  const assure = $('.pdp-assure');
  if (tiles && assure && window.matchMedia) {
    const small = window.matchMedia('(max-width: 959px)');
    const placeTiles = () => { if (small.matches) assure.after(tiles); else tilesHome.appendChild(tiles); };
    placeTiles();
    if (small.addEventListener) small.addEventListener('change', placeTiles); else small.addListener(placeTiles);
  }
  // quick benefits under the description
  const perksList = $('[data-pdp-perks]');
  if (perksList && (PDP_POINTS[p.id] || PERKS[p.id])) perksList.innerHTML = (PDP_POINTS[p.id] || PERKS[p.id].map((t) => [t, ''])).filter(([a, b]) => subLive(p) || !SUB_TEXT.test(`${a} ${b}`)).map(([a, b]) => `<li>${CHECK}<span><strong>${a}</strong>${b ? ` – ${b}` : ''}</span></li>`).join('');
  // "3 Everyday Benefits" band, worded for each product line
  const benefits = $('[data-pdp-benefits]');
  const lineBenefits = LINE_BENEFITS[REVIEW_LINE_OF[p.id]];
  if (benefits && lineBenefits) {
    benefits.hidden = false;
    $('#benefits3-title', benefits).innerHTML = lineBenefits.title;
    $('.benefits3-list', benefits).innerHTML = lineBenefits.items.map(([t, d]) => `<li class="benefits3-item"><span class="benefits3-check" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m6.5 12.5 3.6 3.6 7.4-7.6"/></svg></span><div><h3>${t}</h3><p>${d}</p></div></li>`).join('');
  }
  // "Why CalmPod?": CalmPod compared with calming treats (owner's design, honest rows; 2026-10-21)
  const why = $('[data-pdp-why]');
  if (why) why.hidden = REVIEW_LINE_OF[p.id] !== 'calmpod';
  // one real five-star review next to the buy button
  const quote = $('[data-pdp-quote]');
  const pick = reviewsFor(p).filter((r) => r.stars === 5).sort((a, b) => a.text.length - b.text.length)[0];
  if (quote && pick) {
    quote.hidden = false;
    quote.innerHTML = `<div class="stars" aria-label="5 out of 5 stars">★★★★★</div><blockquote>“${pick.text}”</blockquote><figcaption>${pick.name} · customer review</figcaption>`;
  }
  // star rating under the name, and the reviews for this product further down the page
  const rating = ratingFor(p);
  const ratingLink = $('[data-pdp-rating]');
  const reviewsBlock = $('[data-pdp-reviews]');
  if (rating && ratingLink && reviewsBlock) {
    ratingLink.hidden = false;
    ratingLink.setAttribute('aria-label', `${ratingText(rating)}. Read the reviews`);
    ratingLink.innerHTML = `${starBar(rating.avg)}<span aria-hidden="true">${rating.avg.toFixed(1)}</span>`;
    const list = reviewsFor(p);
    reviewsBlock.hidden = false;
    $('[data-pdp-reviews-sum]', reviewsBlock).innerHTML = `${starBar(rating.avg)} <strong>${rating.avg.toFixed(1)} out of 5</strong> from our ${REVIEW_LINES[REVIEW_LINE_OF[p.id]]} customers`;
    const grid = $('[data-pdp-review-list]', reviewsBlock);
    const marquee = $('[data-review-marquee]', reviewsBlock);
    const ctrl = $('[data-review-ctrl]', reviewsBlock);
    if (list.length >= 3) {
      // a slow, endless strip of every review for this product; hovering, focusing or the button pauses it
      grid.hidden = true;
      const cards = list.map(reviewCard).join('');
      const track = $('[data-review-track]', marquee);
      track.innerHTML = cards + cards.replace(/<article class="review">/g, '<article class="review" aria-hidden="true">');
      track.style.setProperty('--n', list.length);
      marquee.hidden = false;
      ctrl.hidden = false;
      const pauseBtn = $('[data-review-pause]', ctrl);
      pauseBtn.addEventListener('click', () => {
        const paused = marquee.classList.toggle('is-paused');
        pauseBtn.setAttribute('aria-pressed', String(paused));
        pauseBtn.textContent = paused ? 'Play reviews' : 'Pause reviews';
      });
    } else {
      grid.innerHTML = list.map(reviewCard).join('');
    }
  }
  $('[data-pdp-lede]').textContent = `${p.desc} ${g.lede}`;
  $('[data-pdp-badge]').hidden = !p.badge;
  if (p.badge) $('[data-pdp-badge]').textContent = p.badge;
  $('[data-pdp-points]').innerHTML = g.points.map(([k, t]) => `<li>${icon(k)}<span>${t}</span></li>`).join('');
  $('[data-pdp-includes]').innerHTML = p.includes.map((t) => `<li>${t}</li>`).join('');
  $('[data-pdp-details]').innerHTML = g.details.map(([q, a]) => `
    <details><summary>${q}</summary><div class="answer"><p>${a}</p></div></details>`).join('') + `
    <details><summary>Shipping &amp; returns</summary><div class="answer"><p>Free shipping on all orders to UK, EU, USA and Canada, delivered in 5 to 8 business days. Unused, unopened products can be returned within 30 days. <a href="/?view=policies#returns">Returns &amp; refunds</a>.</p></div></details>`;
  const ds = $$('[data-pdp-details] details');
  ds.forEach((d) => d.addEventListener('toggle', () => { if (d.open) ds.forEach((o) => { if (o !== d) o.open = false; }); }));
$('[data-pdp-art]').innerHTML = productArt(p.art);

// product photos for the chosen formula (swipe / arrows / thumbnails), otherwise the illustration
const stage = $('.pdp-stage');
const thumbs = $('[data-gallery-thumbs]');
let galleryKey = null;
// videos added in Shopify ("Product: Videos" section) for this product and pet (2026-10-21)
const videosFor = () => (window.FF_VIDEOS || []).filter((v) => v && v.src && v.for === p.id && (v.pet === 'any' || !usesPet(p) || v.pet === currentPet()))
  .map((v) => ({ video: v.src, poster: v.poster || '', thumb: v.thumb || v.poster || '', alt: v.alt || `${fullName(p)} video` }));
const renderGallery = () => {
  const photos = photosFor(p, photoKey(), p.plugs && (state.plug || preferredPlug()), state.pack);
  const key = photos || `art:${artFor(p, state.pack)}`;
  if (key === galleryKey) return;
  galleryKey = key;
  const art = $('[data-pdp-art]');
  const oldTrack = $('[data-gallery-track]', art);
  const keep = oldTrack ? Math.round(oldTrack.scrollLeft / Math.max(1, oldTrack.clientWidth)) : 0;
  stage.classList.toggle('has-photos', Boolean(photos));
  stage.classList.toggle('one-photo', Boolean(photos) && photos.length === 1); // no arrows or counter for a single photo
  if (!photos) { art.innerHTML = productArt(artFor(p, state.pack)); thumbs.hidden = true; thumbs.innerHTML = ''; art.onclick = null; return; }
  art.innerHTML = `
    <div class="gallery-track" data-gallery-track tabindex="0" role="region" aria-label="Product photos, ${photos.length} images. Use the arrow keys to browse.">
      ${photos.map((ph, i) => `<img src="${ph.large}" alt="${ph.alt}" width="1000" height="1000" decoding="async" ${i === keep ? 'fetchpriority="high"' : 'loading="lazy"'}>`).join('')}
    </div>
    <button class="gallery-nav prev" type="button" aria-label="Previous photo" data-gallery-step="-1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg></button>
    <button class="gallery-nav next" type="button" aria-label="Next photo" data-gallery-step="1"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>
    <span class="gallery-count" data-gallery-count aria-hidden="true">1 / ${photos.length}</span>`;
  thumbs.innerHTML = photos.map((ph, i) => `
    <button type="button" class="gallery-thumb" data-gallery-go="${i}" aria-label="Show photo ${i + 1} of ${photos.length}" aria-current="${i === 0}">
      <img src="${ph.thumb}" alt="" width="200" height="200" loading="lazy" decoding="async">
    </button>`).join('');
  thumbs.hidden = photos.length < 2;
  const track = $('[data-gallery-track]', art);
  let current = 0;
  const show = (i) => {
    $$('.gallery-thumb', thumbs).forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
    $('[data-gallery-count]', art).textContent = `${i + 1} / ${photos.length}`;
  };
  if (keep && keep < photos.length) { current = keep; track.scrollLeft = keep * track.clientWidth; show(keep); }
  const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const go = (i) => { const n = photos.length; track.scrollTo({ left: ((i + n) % n) * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' }); };
  track.addEventListener('scroll', () => {
    const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    if (i === current) return;
    current = i;
    show(i);
  }, { passive: true });
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
  });
  art.onclick = (e) => { const b = e.target.closest('[data-gallery-step]'); if (b) go(current + Number(b.dataset.galleryStep)); };
  thumbs.onclick = (e) => { const t = e.target.closest('[data-gallery-go]'); if (t) go(Number(t.dataset.galleryGo)); };
};
renderGallery();
document.addEventListener('ff:petchange', renderGallery);
// "See it in action": the product's videos in their own section under the reviews (owner, 2026-10-21).
// Each plays silently while it is on screen; a tap pauses or plays it. Visitors who prefer less motion get controls.
const vSec = $('[data-pdp-videos]');
const drawVideos = () => {
  if (!vSec) return;
  const vids = videosFor();
  const row = $('[data-pdp-videos-row]', vSec);
  vSec.hidden = !vids.length && !window.FF_DESIGN;
  if (!vids.length) { row.innerHTML = window.FF_DESIGN ? '<p class="pv-empty">Add videos in the theme editor: “Product: Videos” → Add block → Video.</p>' : ''; return; }
  row.innerHTML = vids.map((v) => `<figure class="pv-card"><video src="${v.video}"${v.poster ? ` poster="${v.poster}"` : ''} muted loop playsinline preload="none" aria-label="${escHTML(v.alt)}"${REDUCE_MOTION ? ' controls' : ''}></video><span class="pv-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l11-6.5Z"/></svg></span></figure>`).join('');
  if (REDUCE_MOTION) return;
  $$('video', row).forEach((el) => {
    const card = el.parentElement;
    addSoundButton(el, card);
    if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => {
      if (en.isIntersecting && !card.classList.contains('is-held')) { el.preload = 'auto'; el.play().catch(() => {}); } else el.pause();
    }, { threshold: 0.5 }).observe(el);
    card.addEventListener('click', () => {
      if (el.paused) { card.classList.remove('is-held'); el.play().catch(() => {}); } else { card.classList.add('is-held'); el.pause(); }
    });
  });
};
drawVideos();
document.addEventListener('ff:petchange', drawVideos);
// warm the cache with the other plug's photos once the page is idle, so switching is instant.
// Not on phones (the thumbnail strip is hidden there) or when the visitor has asked to save data.
const saveData = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
if (p.images && p.plugs && !saveData && !window.matchMedia('(max-width: 600px)').matches) {
  const warm = () => [...Object.values(p.images).flat(), ...Object.values(p.packImages || {})].forEach((ph) => { new Image().src = ph.thumb; });
  ('requestIdleCallback' in window) ? requestIdleCallback(warm, { timeout: 3000 }) : setTimeout(warm, 1500);
}
  $('[data-pdp-peek]').dataset.group = p.group;
  $('[data-formula-field]').hidden = !usesPet(p) || Boolean(p.pets && p.pets.length === 1);
  // a cat-only (or dog-only) product switches the site to that pet, once the page's scripts are ready
  const matchPet = () => { if (p.pets && !p.pets.includes(currentPet())) $(`[data-pet-choice="${p.pets[0]}"]`)?.click(); };
  // (main.js wires the Cat/Dog switch after this script, so wait for DOMContentLoaded unless the page has fully loaded)
  if (document.readyState === 'complete') matchPet(); else document.addEventListener('DOMContentLoaded', matchPet);
  $$('[data-pdp-chip], [data-pdp-bar-formula]').forEach((el) => { el.hidden = !usesPet(p); });
  $('[data-plan-field]').hidden = !subLive(p);
  if (p.subscribe && !subLive(p)) { const once = $('input[name=plan][value=once]'); if (once) once.checked = true; } // subscriptions not set up in Shopify yet
  if (p.subscribe) $('#pdp-freq').value = String(p.subscribe.every || 90);
const packField = $('[data-pack-field]');
if (packField) {
  packField.hidden = !p.packs;
  if (p.packs) {
    $('[data-pack-options]').innerHTML = bundleRows(p, state.pack);
    $('[data-pack-options]').style.setProperty('--packs', p.packs.length);
    packField.addEventListener('change', (e) => { if (e.target.name === 'pack') { state.pack = Number(e.target.value); renderGallery(); } });
  }
}
const kitField = $('[data-kit-plan-field]');
if (kitField && p.kitPlan && subLive(findProduct(KIT_REFILLS))) { kitField.hidden = false; $('[data-kit-plan-slot]').innerHTML = kitPlanUI('pdp-kitplan'); }
const plugField = $('[data-plug-field]');
if (plugField) {
  plugField.hidden = !p.plugs;
  if (p.plugs) {
    state.plug = preferredPlug();
    $('[data-plug-options]').innerHTML = p.plugs.map((k) => `
      <label class="plug-opt">
        <input type="radio" name="plug" value="${k}" ${k === state.plug ? 'checked' : ''}>
        ${plugIcon(k)}<span class="plug-name">${PLUGS[k].name}</span><span class="plug-where">${PLUGS[k].where}</span>
      </label>`).join('');
    plugField.addEventListener('change', (e) => { if (e.target.name === 'plug') { state.plug = e.target.value; savePlug(state.plug); renderGallery(); } });
  }
}

// The Calm Mix: with 2 or 3 refills the customer picks Feline or Canine for each one
const field = $('[data-formula-field]');
let three = null;
const mixMin = p.mix ? (p.mix.min || 2) : 0;
const vialsFor = (key) => { const c = mixCounts(key) || { cat: 1, dog: 1 }; return [...Array(c.cat).fill('cat'), ...Array(c.dog).fill('dog')]; };
// which choices the store sells (everything, on the plain website)
const soldAs = (f, n) => !LIVE || okVariant(variantIdFor(p, f, null, n));
const mixesAt = (n) => Object.keys(p.variants || {}).filter((key) => { const c = mixCounts(key); return c && c.cat + c.dog === n && (!LIVE || okVariant(p.variants[key])); });
const sizes = () => (p.packs || []).map((x) => x.n);
const setPack = (n) => { state.pack = n; const r = $(`[data-pack][value="${n}"]`); if (r) r.checked = true; };
state.vials = p.mix ? vialsFor(mixesAt(Math.max(mixMin, state.pack || 1))[0]) : [];
// keep the formula and the size a combination that can be bought
const fitFormula = () => {
  if (!p.mix) return;
  const n = state.pack || 1;
  if (state.formula === 'mix') {
    if (n < mixMin || !mixesAt(n).length) state.formula = currentPet();
    else if (state.vials.length !== n || !soldAs(currentFormula(), n)) state.vials = vialsFor(mixesAt(n)[0]);
  }
  if (state.formula !== 'mix' && !soldAs(state.formula, n) && n >= mixMin && mixesAt(n).length) { state.formula = 'mix'; state.vials = vialsFor(mixesAt(n)[0]); }
};
const currentFormula = () => {
  if (state.formula !== 'mix') return state.formula;
  const cats = state.vials.filter((v) => v === 'cat').length, dogs = state.vials.length - cats;
  return dogs === 0 ? 'cat' : cats === 0 ? 'dog' : `mix-${cats}-${dogs}`;
};
const vialArt = (who) => `<svg viewBox="0 0 40 64" aria-hidden="true"><rect x="10" y="2" width="20" height="9" rx="3" fill="#FFFDFA" stroke="#E2D6C3"/><rect x="6" y="10" width="28" height="50" rx="10" fill="${who === 'cat' ? '#9DB383' : '#D9B27A'}"/><rect x="11" y="16" width="5" height="36" rx="2.5" fill="#fff" opacity=".5"/></svg>`;
if (p.mix) {
  const sw = $('.pet-switch', field);
  const catIcon = $('[data-pet-choice="cat"] svg', sw).outerHTML;
  const dogIcon = $('[data-pet-choice="dog"] svg', sw).outerHTML;
  sw.hidden = true;
  field.insertAdjacentHTML('beforeend', `
    <div class="pet-switch three" role="radiogroup" aria-labelledby="formula-label" data-formula3>
      <button type="button" role="radio" data-f="cat">${catIcon}Cat</button>
      <button type="button" role="radio" data-f="dog">${dogIcon}Dog</button>
      <button type="button" role="radio" data-f="mix"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20s-7-4.3-8.8-8.6C1.8 8.1 3.9 4.8 7.2 4.8c1.9 0 3.3 1.1 4.8 2.8 1.5-1.7 2.9-2.8 4.8-2.8 3.3 0 5.4 3.3 4 6.6C19 15.7 12 20 12 20Z"/></svg>Calm Mix</button>
      <span class="pet-switch-pill" aria-hidden="true"></span>
    </div>
    <div class="mix-builder" data-mix-builder hidden>
      <p class="mix-note"><strong>Build your Calm Mix.</strong> Tap a refill to switch it between Feline and Canine.</p>
      <div class="mix-vials" role="group" aria-label="Choose the formula for each refill" data-mix-vials></div>
      <p class="mix-summary" data-mix-summary aria-live="polite"></p>
    </div>`);
  three = $('[data-formula3]', field);
  if (mixOnly(p)) three.hidden = true; // the store sells only mixes: no Cat / Dog choice
  fitFormula();
  renderGallery();
  // after a size change: a mix needs 2 or more refills, and the formula must be one the store sells in that size
  packField?.addEventListener('change', (e) => { if (e.target.name === 'pack') { fitFormula(); renderGallery(); } });
  const choose = (f, focus) => {
    state.formula = f;
    // choosing the mix on 1 refill moves to the smallest size that has one; a formula not sold in this size moves size too
    if (f === 'mix' && ((state.pack || 1) < mixMin || !mixesAt(state.pack || 1).length)) { const n = sizes().find((x) => x >= mixMin && mixesAt(x).length); if (n) setPack(n); }
    if (f !== 'mix' && !soldAs(f, state.pack || 1)) { const n = sizes().find((x) => soldAs(f, x)); if (n) setPack(n); }
    if (f === 'mix' && state.vials.length !== state.pack) state.vials = vialsFor(mixesAt(state.pack)[0]);
    if (f !== 'mix' && f !== currentPet()) $(`[data-pet-choice="${f}"]`, sw).click(); // also re-themes the site
    renderGallery();
    sync();
    if (focus) $(`[data-f="${f}"]`, three).focus();
  };
  three.addEventListener('click', (e) => { const btn = e.target.closest('[data-f]'); if (btn) choose(btn.dataset.f); });
  three.addEventListener('keydown', (e) => {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return;
    e.preventDefault();
    const order = ['cat', 'dog', 'mix'];
    const i = order.indexOf(state.formula) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : 2);
    choose(order[i % 3], true);
  });
  $('[data-mix-vials]', field).addEventListener('click', (e) => {
    const v = e.target.closest('[data-vial]');
    if (!v) return;
    const i = Number(v.dataset.vial);
    state.vials[i] = state.vials[i] === 'cat' ? 'dog' : 'cat';
    // only combinations the store sells (in Shopify the mix always has both formulas)
    if (!soldAs(currentFormula(), state.pack || 1)) { state.vials[i] = state.vials[i] === 'cat' ? 'dog' : 'cat'; return; }
    renderGallery(); // the photo matches the mix: 2 cat + 1 dog, 1 cat + 2 dog, or all one pet
    sync();
    $(`[data-vial="${i}"]`, field).focus();
  });
  document.addEventListener('ff:petchange', () => { if (state.formula !== 'mix') { state.formula = currentPet(); sync(); } });
}

  const planIsSub = () => subLive(p) && $('input[name=plan][value=sub]', pdp).checked;
  const unit = () => (planIsSub() ? subPriceOf(p, packOf(p, state.pack)) : packOf(p, state.pack).price);
  // "Complete the calm routine" (2026-10-21): the kit for home plus CalmMist for trips, on both their pages
  const routine = $('[data-pdp-routine]');
  const drawRoutine = () => {
    if (!routine) return;
    const kit = findProduct('starter'), mist = findProduct('spray');
    const pet = currentPet() === 'dog' ? 'dog' : 'cat';
    const onKit = p.id === 'starter';
    const plug = onKit ? state.plug : preferredPlug();
    const kp = onKit ? state.pack : 1;
    const kk = kit && packOf(kit, kp, pet, plug), mk = mist && packOf(mist, 1, pet);
    routine.hidden = !(kit && mist && (onKit || p.id === 'spray') && kk.available !== false && mk.available !== false);
    if (routine.hidden) return;
    const kph = photosFor(kit, pet, plug, kp), mph = photosFor(mist, pet);
    const shot = (ph, prod, n) => (ph ? `<img src="${ph[0].thumb}" alt="" width="120" height="120" loading="lazy" decoding="async">` : productArt(artFor(prod, n)));
    routine.innerHTML = `
      <p class="pdp-section-label"><span>Complete The Calm Routine</span></p>
      <div class="routine-card">
        <div class="routine-items">
          <figure>${shot(kph, kit, kp)}<figcaption>CalmPod At Home</figcaption></figure>
          <span class="routine-plus" aria-hidden="true">+</span>
          <figure>${shot(mph, mist, 1)}<figcaption>CalmMist On The Go</figcaption></figure>
        </div>
        <p class="routine-why">The diffuser keeps every day calm at home. The spray takes that calm into carriers, vet visits and car journeys.</p>
        <div class="routine-buy">
          <p class="routine-price">Both For <strong>${money(kk.price + mk.price)}</strong></p>
          <button class="btn add-btn cta-buy routine-add" type="button" data-routine-add><span class="cta-label">Add Both To Cart</span></button>
        </div>
        <p class="routine-note">${fullName(kit, pet)}${kp > 1 ? ` × ${kp}` : ''} (${plug} plug) + ${fullName(mist, pet)}${onKit ? '' : ` · <a href="${itemUrl(kit)}">Choose another plug or size</a>`}</p>
      </div>`;
  };
  routine?.addEventListener('click', (e) => {
    if (!e.target.closest('[data-routine-add]')) return;
    const pet = currentPet() === 'dog' ? 'dog' : 'cat';
    const onKit = p.id === 'starter';
    addToCart('starter', null, 1, pet, onKit ? state.plug : preferredPlug(), onKit ? state.pack : 1);
    addToCart('spray', null, 1, pet);
    toast(`${fullName(findProduct('starter'), pet)} + ${fullName(findProduct('spray'), pet)} added to cart`);
  });
  const sync = () => {
    // subscription only where this formula and size can be subscribed to
    if (p.subscribe) {
      const can = subAt(p, p.mix && typeof currentFormula === 'function' ? currentFormula() : petFor(p), state.pack);
      $('[data-plan-field]').hidden = !can;
      const subBox = $('input[name=plan][value=sub]', pdp);
      if (!can && subBox && subBox.checked) { const once = $('input[name=plan][value=once]', pdp); if (once) once.checked = true; }
    }
    $$('.opt', pdp).forEach((o) => o.classList.toggle('is-checked', $('input', o).checked));
    if (p.subscribe) {
      $('[data-sub-price]', pdp).textContent = money(subPriceOf(p, packOf(p, state.pack)));
      $('[data-once-price]', pdp).textContent = money(packOf(p, state.pack).price);
    }
    $('[data-pdp-price]').textContent = money(unit() * state.qty);
    const k = packOf(p, state.pack);
    const was = $('[data-pdp-was]');
    was.hidden = !k.compareAt || planIsSub();
    if (k.compareAt) was.textContent = money(k.compareAt * state.qty);
    if (p.packs) {
      $$('.pack-opt', pdp).forEach((o) => o.classList.toggle('is-checked', $('input', o).checked));
      $('[data-pdp-badge]').hidden = !k.badge;
      if (k.badge) $('[data-pdp-badge]').textContent = k.badge;
    }
    if (p.kitPlan) syncKitPlan($('[data-kit-plan]', pdp), k.n);
    // "1 diffuser = 1 room · Each refill = 30 days" under the kit sizes (owner, 2026-10-21)
    const facts = $('[data-pack-facts]', pdp);
    if (facts) { facts.hidden = !p.kitPlan; if (p.kitPlan) $('[data-pack-rooms]', facts).textContent = `${k.n} ${k.n > 1 ? 'diffusers' : 'diffuser'} = ${k.n} ${k.n > 1 ? 'rooms' : 'room'}`; }
    drawRoutine();
$('[data-pdp-qty-val]').textContent = state.qty;
if (three) {
  const order = ['cat', 'dog', 'mix'];
  $$('[data-f]', three).forEach((btn) => btn.setAttribute('aria-checked', String(btn.dataset.f === state.formula)));
  three.style.setProperty('--i', order.indexOf(state.formula));
  const isMix = state.formula === 'mix';
  const f = currentFormula();
  $('[data-mix-builder]').hidden = !isMix;
  if (isMix) {
    $('[data-mix-vials]').innerHTML = state.vials.map((v, i) => `
      <button type="button" class="mix-vial ${v}" data-vial="${i}" aria-label="Refill ${i + 1}: ${v === 'cat' ? 'Feline' : 'Canine'}. Tap to switch.">
        ${vialArt(v)}<span>${v === 'cat' ? 'Feline' : 'Canine'}</span>
      </button>`).join('');
    $('[data-mix-summary]').textContent = mixCounts(f)
      ? `Your mix: ${mixText(f)}`
      : `Your mix: all ${f === 'cat' ? 'Feline' : 'Canine'} (same as the ${petLabel(f)} Formula)`;
  }
  const vialsText = mixCounts(f) ? mixText(f) : `${state.vials.length} ${f === 'cat' ? 'Feline' : 'Canine'}`;
  $$('[data-pdp-chip]').forEach((c) => { c.innerHTML = isMix ? 'The Calm Mix' : '<span data-pet-name>' + petLabel(currentPet()) + '</span> Formula'; });
  $$('[data-pdp-bar-formula]').forEach((c) => { c.innerHTML = isMix ? 'The Calm Mix' : `<span data-pet-name>${petLabel(currentPet())}</span> Formula`; });
  $('[data-pdp-includes]').innerHTML = (isMix ? [`The Calm Mix: ${vialsText} × 48 ml refills (about ${state.vials.length * 30} days)`, ...p.includes.slice(1)] : p.includes).map((t) => `<li>${t}</li>`).join('');
}
    $$('.plug-opt', pdp).forEach((o) => o.classList.toggle('is-checked', $('input', o).checked));
    if (p.packs && !p.plugs && !(three && state.formula === 'mix')) $('[data-pdp-includes]').innerHTML = k.includes.map((t) => `<li>${t}</li>`).join('');
    if (p.plugs) $('[data-pdp-includes]').innerHTML = [...k.includes, `${PLUGS[state.plug].name} plug${k.n > 1 ? 's' : ''} (${PLUGS[state.plug].type}, ${PLUGS[state.plug].where})`].map((t) => `<li>${t}</li>`).join('');
    const shown = fullName(p, p.mix ? currentFormula() : currentPet());
    $('[data-pdp-title]').textContent = shown;
    $('[data-crumb-name]').textContent = shown;
    document.title = shown.startsWith('FurrFlora') ? shown : `${shown} — FurrFlora`;
    shareTags(shown);
    $$('[data-pdp-bar-name]').forEach((el) => { el.textContent = p.plugs ? `${shown}${k.n > 1 ? ` × ${k.n}` : ''} · ${state.plug} plug` : `${shown}${p.packs && k.n > 1 ? ` × ${k.n}` : ''}`; });
    $$('.bundle-row', pdp).forEach((o) => o.classList.toggle('is-checked', $('input', o).checked));
    $$('[data-po-card]', pdp).forEach((c) => c.classList.toggle('is-checked', $('input', c).checked));
    if (p.subscribe) {
      const kk = packOf(p, state.pack);
      $('[data-once-strike]', pdp).textContent = money(regularPrice(kk));
      if (p.subscribe.prices) {
        $('[data-sub-tag]', pdp).textContent = `Save ${money(subSaving(p, kk))}`;
        $('[data-sub-extra]', pdp).textContent = kk.n > 1 ? `${money(subSaving(p, kk))} less than ${kk.n} single refills, every delivery` : `${money(subSaving(p, kk))} off every delivery`;
      } else {
        const pct = Math.round(p.subscribe.discount * 100);
        $('[data-sub-tag]', pdp).textContent = `Save ${pct}%`;
        $('[data-sub-extra]', pdp).textContent = `Extra ${pct}% off every order`;
      }
    }
    // regular price struck through next to the price you pay (subscription or multi-pack)
    const wasEl = $('[data-pdp-was]');
    const wasVal = planIsSub() ? regularPrice(packOf(p, state.pack)) : k.compareAt;
    wasEl.hidden = !wasVal;
    if (wasVal) wasEl.textContent = money(wasVal * state.qty);
    $('.pdp-price-row').classList.toggle('has-sale', Boolean(wasVal));
    // value per day, worked out from the price paid and how long it lasts
    const perDayEl = $('[data-pdp-perday]');
    if (perDayEl && DAYS_OF_USE[p.id]) {
      const rooms = p.kitPlan ? k.n : 1;
      const perDay = unit() / rooms / DAYS_OF_USE[p.id](k.n);
      perDayEl.hidden = false;
      perDayEl.innerHTML = `That's about <strong>${money(perDay)} a day</strong>${rooms > 1 ? ' per room' : ''}`;
    }
    // what the shopper saves on this choice (subscription discount or multi-pack price), shown by the price
    const saveEl = $('[data-pdp-save]');
    if (saveEl) {
      const full = planIsSub() ? regularPrice(packOf(p, state.pack)) : (k.compareAt || 0);
      const saved = (full - unit()) * state.qty;
      saveEl.hidden = !(saved > 0.004);
      if (saved > 0.004) saveEl.textContent = `You save ${money(saved)} (${Math.round((1 - unit() / full) * 100)}%)`;
    }
    // the Add to cart buttons carry what is paid today, including a kit's refill subscription (charged at checkout)
    const kitSub = p.kitPlan && kitPlanChoice($('[data-kit-plan]', pdp)) ? kitPlanPrice(state.pack) : 0;
    $$('[data-cta-price]').forEach((el) => { el.textContent = money((unit() + kitSub) * state.qty); });
    const subNote = $('[data-sub-note]', pdp);
    if (subNote) {
      subNote.hidden = !planIsSub();
      if (planIsSub()) subNote.innerHTML = `You’ll be charged <strong>${money(unit() * state.qty)}</strong> today, then <strong>${money(unit() * state.qty)} every ${$('[data-freq]', pdp).value} days</strong> until you cancel.`;
    }
  };
  pdp.addEventListener('change', sync);
  document.addEventListener('ff:petchange', () => sync()); // the name says "for Cats" / "for Dogs"
  pdp.addEventListener('click', (e) => {
    const step = e.target.closest('[data-pdp-qty]');
    if (step) { state.qty = Math.min(10, Math.max(1, state.qty + Number(step.dataset.pdpQty))); sync(); }
  });
  document.addEventListener('click', (e) => {
    const add = e.target.closest('[data-pdp-add]');
    if (!add) return;
    const formula = p.mix ? currentFormula() : undefined;
    addToCart(p.id, planIsSub() ? $('[data-freq]', pdp).value : null, state.qty, formula, p.plugs ? state.plug : undefined, state.pack);
    const refillEvery = p.kitPlan && kitPlanChoice($('[data-kit-plan]', pdp));
    if (refillEvery) addToCart(KIT_REFILLS, refillEvery, state.qty, formula || currentPet(), undefined, kitRefills(state.pack));
    $$('[data-pdp-add]').forEach((b) => { b.classList.remove('added'); void b.offsetWidth; b.classList.add('added'); });
    const extras = [p.packs && state.pack > 1 ? packOf(p, state.pack).label : '', mixCounts(formula) ? shortFormula(formula) : '', p.plugs ? `${state.plug} plug` : ''].filter(Boolean).join(', ');
    if (p.kitPlan && !refillEvery && kitUpsell({ pet: currentPet(), pack: state.pack, qty: state.qty, from: add })) return;
    toast(`${state.qty} × ${fullName(p, formula || currentPet())}${extras ? ` (${extras})` : ''}${refillEvery ? ' + refill subscription' : ''} added to cart`);
  });
  const bar = $('[data-pdp-bar]');
  const mainAdd = $('.pdp-add');
  if (bar && mainAdd && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => bar.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(mainAdd);
  }
  sync();

  // "You might also like": the other options in this range, then one from each other range.
  // Rebuilt when the pet changes (and once the saved pet has loaded), so cat-only items never show for dogs.
  const renderRelated = () => {
    const ok = (x) => !x.hidden && sellable(x) && (!x.pets || x.pets.includes(currentPet()));
    const related = [
      ...PRODUCTS.filter((x) => x.group === p.group && x.id !== p.id && ok(x)),
      ...Object.keys(GROUPS).filter((k) => k !== p.group).map((k) => PRODUCTS.find((x) => x.group === k && ok(x))).filter(Boolean),
    ].slice(0, 3);
    const wrap = $('[data-related]');
    if (!wrap) return;
    wrap.style.setProperty('--n', related.length);
    wrap.innerHTML = related.map(productCard).join('');
    window.FF?.observeReveals?.(wrap);
    $$('.reveal', wrap).forEach((el) => el.classList.add('in')); // already on screen when rebuilt
  };
  renderRelated();
  document.addEventListener('ff:petchange', renderRelated);
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', renderRelated);
}

renderShop();
initFinder();
fillPayIcons();
// the home page video (set in Shopify): plays while on screen; visitors who prefer less motion get the controls instead
$$('[data-home-video] video').forEach((v) => {
  if (REDUCE_MOTION) { v.removeAttribute('autoplay'); v.pause(); v.controls = true; return; }
  addSoundButton(v, v.closest('.home-video-frame') || v.parentElement);
  if ('IntersectionObserver' in window) new IntersectionObserver(([en]) => { if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }).observe(v);
});
renderCart();
initItemPage();
